/* eslint-disable react/no-unescaped-entities */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import s from './s.module.less';
import {
    Input,
    Collapse,
    Popover,
    InputNumber,
    Switch,
    Select,
    Tooltip,
    Checkbox,
    Button,
    Modal,
    Radio,
    message,
    Tag,
} from 'antd';
import {
    KlarityService,
    ServerMeta,
    AddressPublicType,
    EContactType,
    KlarityServiceTypeTemplate,
    KlarityServiceTypeValue,
    TKlarityStateTPrice,
    EServiceType,
    TKlarityPrice,
    ServerKlarityService,
    TServiceStateItem,
    TPatientGroupLimitation,
    TMedication,
    TConfigMedication,
    TInsuranceInput,
    TInsurance,
    InsuranceSetting,
    CarrierSetting,
    EIntakeFormType,
} from 'types/common';
import CommonTable from 'components/CommonTable';
import { ColumnsType } from 'antd/es/table';
import { getKlarityPriceLevel } from 'utils/service';
import {
    ESpecialty,
    LA_FIRE_SPE_NAME,
    SPECIALTY_TIPS_MAP,
    LA_FIRE_SERVICE_PRICE,
    INSURANCE_TYPE_CASH_AND_INSURANCE,
    INSURANCE_TYPE_CASH,
    INSURANCE_TYPE_INSURANCE,
    WEIGHT_LOSS_15_MINS_TEMPLATE,
    KLAIRTY_TEMPLATE_PRICE_MAP,
} from 'constants/common';
import AvaIcon from 'assets/common/ava.png';
import { PracitceAddressForm } from 'types/practiceFront';
import { getUserId } from 'utils/localstore';
import { isSameStringArray } from 'data/provider';
import useGetSettingData from 'hooks/useGetSettingData';
import { EnumFields } from 'types/enumerationData';
import EarningEditor from 'components/EarningEditor';
import MedicationSelect from 'components/MedicationSelect';
import InsuranceSelectionModal from 'components/InsuranceSelectionModal';
import { IInsurance } from 'types/insurance';
import { Provider, UniprofileFormData } from 'types/provider';
import InsuranceTable from 'components/PPAOnboarding/InsuranceTable';
import { IPPAServicePriceConfigResponse } from 'types/ppaOnboarding';
import UniprofileStepDataStore from 'store/UniprofileStepData';
import { getPaymentType } from 'utils/serviceTemplate';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';
import BillingCodesAndRates from './components/BillingCodesAndRates';
import { TCPTCode } from 'types/insuranceBilling';
import usePlaceOfServiceCodeOptions from 'hooks/usePlaceOfServiceCodeOptions';
import useModifierOptions from 'hooks/useModifierOptions';
import useIntakeFormConfig from 'hooks/useIntakeFormConfig';
import { getHelloKlarityHost } from 'utils/common';
// customizedServiceName
type PigInfo = {
    states?: ServerMeta[];
    accept?: string[];
    contactType?: EContactType[];
    limitations?: string[];
    isAddingLimit?: boolean;
    pendingNewLimit?: string;
};

type StrMeta = {
    label: string;
    value: string;
};

type IProps = {
    handleGetPricesNRange: (v: number, state: string) => Record<string, TKlarityStateTPrice>;
    generatePrices: (v: number, state: string) => void;
    serviceTypeTemplate?: KlarityServiceTypeTemplate;
    serviceTypeTemplateValue?: KlarityServiceTypeValue;
    allStateConfigTypePriceData?: Record<string, TKlarityStateTPrice>;
    serviceType: EServiceType;
    service?: KlarityService;
    allowStates?: ServerMeta[];
    defaultOpen?: boolean;
    onServiceTypeInfoUpdate?: (info: ServerKlarityService) => void;
    onDisabled?: (disabled: boolean) => void;
    onNameIsExistedError?: (isExist: boolean) => void;
    allEditingNames: string[];
    editValue?: ServerKlarityService;
    isAdd?: boolean;
    onRemove?: () => void;
    isOps?: boolean;
    providerId?: number;
    addressList?: PracitceAddressForm[];
    allStatesFromService?: ServerMeta[];
    onInitVisitStateChange?: (states: ServerMeta[]) => void;
    forceDetectMedicationFlag?: {};
    isKiwiUser?: boolean;
    uniprofileInsuranceData?: IInsurance[];
    stateFromInitVisit?: ServerMeta[];
    provider?: UniprofileFormData;
    disablePriceNDurationEdit?: boolean;
    disableContactTypeEdit?: boolean;
    forceEnableStateSelect?: boolean;
    disablePatientCostEdit?: boolean;
    klarityTemplate?: string;
    paymentTypeConfig?: {
        cashPay: {
            show: boolean;
            disable: boolean;
        };
        insurancePay: {
            show: boolean;
            disable: boolean;
        };
    };
    forceHideCloseSwitch?: boolean;
    // insuranceComponent?: React.ReactNode;
    useInsuranceComponent?: boolean;
    servicePriceConfig?: IPPAServicePriceConfigResponse[];
};

const splitsymbol = ':';
const PAMENT_TYPES = {
    cash: 1,
    insurance: 2,
    both: 3,
};

const CONTROLED_MEDICATION_REFILLS_TYPES = {
    yes: 'yes',
    no: 'no',
};

const paymentMethodNameMapToNumber = {
    [PAMENT_TYPES.cash]: INSURANCE_TYPE_CASH,
    [PAMENT_TYPES.insurance]: INSURANCE_TYPE_INSURANCE,
    [PAMENT_TYPES.both]: INSURANCE_TYPE_CASH_AND_INSURANCE,
};

const ConfigServiceType = (props: IProps) => {
    const {
        forceEnableStateSelect,
        disablePriceNDurationEdit,
        disableContactTypeEdit,
        disablePatientCostEdit,
        addressList,
        isAdd,
        onRemove,
        serviceTypeTemplate,
        serviceTypeTemplateValue,
        allEditingNames,
        allStateConfigTypePriceData,
        serviceType,
        service,
        onServiceTypeInfoUpdate,
        onDisabled,
        defaultOpen,
        onNameIsExistedError,
        allowStates,
        editValue,
        isOps,
        providerId,
        onInitVisitStateChange,
        allStatesFromService,
        generatePrices,
        forceDetectMedicationFlag,
        handleGetPricesNRange,
        isKiwiUser,
        uniprofileInsuranceData,
        stateFromInitVisit,
        provider,
        klarityTemplate,
        paymentTypeConfig,
        forceHideCloseSwitch,
        insuranceComponent,
        useInsuranceComponent,
        servicePriceConfig,
    } = props;
    const pgiAcceptOption: StrMeta[] =
        serviceTypeTemplate?.klarityServiceTypePatientGroupList?.map((item) => {
            return {
                label: item.patientGroup,
                value: `${item.patientGroup}`,
            };
        }) || [];

    const pgiLmitOption: StrMeta[] =
        serviceTypeTemplate?.klarityServiceTypeLimitationList?.map((item) => {
            return {
                label: item.limitation,
                value: `${item.limitation}`,
            };
        }) || [];

    const contactTypeOption: StrMeta[] = [EContactType.TELE_HEALTH, EContactType.IN_PERSON]?.map((str) => {
        return { label: str, value: str };
    });
    const [pgiLmitExtraOption, setPgiLmitExtraOption] = React.useState<StrMeta[]>([]);

    const [stateAddressIdsMap, setStateAddressIdsMap] = React.useState<Record<string, string[]>>({});
    const [stateContactTypeMap, setStateContactTypeMap] = React.useState<Record<string, EContactType[]>>({});
    const [stateTelehealthPosMap, setStateTelehealthPosMap] = React.useState<Record<string, string>>({});
    const [stateInPersonPosMap, setStateInPersonPosMap] = React.useState<Record<string, string>>({});
    const [stateTelehealthModifierMap, setStateTelehealthModifierMap] = React.useState<Record<string, string>>({});
    const [stateInPersonModifierMap, setStateInPersonModifierMap] = React.useState<Record<string, string>>({});
    const [placeOfServiceCodeOptions] = usePlaceOfServiceCodeOptions(service?.specialtyName, isOps, providerId);
    const [modifierOptions] = useModifierOptions(service?.specialtyName, isOps, providerId);

    const [pgiIsOpen, setPgiIsOpen] = React.useState(true);
    const [pendingPgiInfo, setPendingPgiInfo] = React.useState<PigInfo[]>([{}]);

    const [states, setStates] = React.useState<string[]>([]);
    const [initStatesFromEdit, setInitStatesFromEdit] = React.useState<string[]>([]);
    const [hasInitState, setHasInitState] = React.useState(false);
    const [pendingCustomizeName, setPendingCustomizeName] = React.useState<string>('');
    const [pendingDescription, setPendingDescription] = React.useState(serviceTypeTemplate?.description);
    const [pendingPaymentType, setPendingPaymentType] = React.useState<number[]>([]);
    // 给Insurancetable使用，因为InsuranceTable接受的是CASH,INSURANCE这类具体的名字，而不是pendingPaymentType的1,2,3
    const [paymentMethodName, setPaymentMethodName] = React.useState<
        typeof INSURANCE_TYPE_CASH | typeof INSURANCE_TYPE_INSURANCE | typeof INSURANCE_TYPE_CASH_AND_INSURANCE
    >();

    const [nameIsExistInServerError, setNameIsExistInServerError] = React.useState(false);

    const [stateContentMyEaringMap, setStateContentMyEaringMap] = React.useState<Record<string, number>>({});
    const [stateContentDurationMap, setStateContentDurationMap] = React.useState<Record<string, number>>({});

    const [stateContentInsuranceCarrierMap, setStateContentInsuranceCarrierMap] = React.useState<
        Record<string, string[]>
    >({});
    const [stateContentInsurancePlanMap, setStateContentInsurancePlanMap] = React.useState<
        Record<string, Record<string, string[]>>
    >({});
    const [stateContentPatientCostMap, setStateContentPatientCostMap] = React.useState<Record<string, number>>({});
    const [stateContentSuperBillSupportMap, setStateContentSuperBillSupportMap] = React.useState<
        Record<string, boolean>
    >({});
    const [stateContentPriorAuthorizationSupportMap, setStateContentPriorAuthorizationSupportMap] = React.useState<
        Record<string, boolean>
    >({});
    const [stateContentInsuranceDurationMap, setStateContentInsuranceDurationMap] = React.useState<
        Record<string, number>
    >({});

    const [stateContentShippingFeeMap, setStateContentShippingFeeMap] = React.useState<Record<string, number>>({});

    const [coldChain, setColdChain] = React.useState<boolean>();
    const [shippingRestriction, setShippingRestriction] = React.useState('');
    const [pendingCptCodes, setPendingCptCodes] = React.useState<TCPTCode[]>(editValue?.cpts || []);

    const [allStates] = useGetSettingData(EnumFields.STATE);

    const [isDisabled, setIsDisabled] = React.useState(false);
    const [activeKey, setActiveKey] = React.useState<string[]>(
        defaultOpen ? [serviceTypeTemplate?.serviceType as string] : [],
    );

    const [medicationList, setMedicationList] = React.useState<TConfigMedication[]>([]);
    const [defaultMedicationList, setDefaultMedicationList] = React.useState<TConfigMedication[]>([]);
    const [showMedicationEmpty, setShowMedicationEmpty] = React.useState(false);

    const displayName = serviceTypeTemplate?.displayName || serviceTypeTemplate?.serviceType || '';
    const ehrName = `${service?.specialtyName}${pendingCustomizeName || ''}${serviceTypeTemplate?.displayName}`;
    const nameExistInEditing =
        allEditingNames && allEditingNames.indexOf(ehrName) !== allEditingNames.lastIndexOf(ehrName);

    const addressOptions: PracitceAddressForm[] =
        isOps && addressList ? addressList : provider?.practice?.addressList || [];
    const serviceId: number | undefined = editValue?.serviceId || undefined;
    const isEdit = !!serviceId;

    const isConsultation = serviceType === EServiceType.CONSULTATION;
    const consultationOverPrice = 10;
    const isInit = serviceTypeTemplate?.serviceType === EServiceType.INIT;
    const isMedications = serviceTypeTemplate?.serviceType === EServiceType.MEDICATIONS;

    //2026-01
    const [pendingOpenPatientIntakeForms, setPendingOpenPatientIntakeForms] = React.useState(false);
    const [pendingControlledMedicationRefillsType, setPendingControlledMedicationRefillsType] = React.useState<string>(
        CONTROLED_MEDICATION_REFILLS_TYPES.no,
    );
    const [pendingControlledMedicationRefillsMaxAmount, setPendingControlledMedicationRefillsMaxAmount] =
        React.useState<number>();

    const isPrescriptionService = serviceTypeTemplate?.serviceType === EServiceType.PRESCRIPTION_SERVICE;
    const showControlledMedicationRefills = serviceTypeTemplate?.serviceType === EServiceType.PRESCRIPTION_SERVICE;
    const [intakeFormConfig] = useIntakeFormConfig(service?.specialtyName || '', serviceType, isOps);
    let showIntakeFormConfig = intakeFormConfig && intakeFormConfig.length > 0;

    const showInitVisitBasicIntakeForm = !!(
        intakeFormConfig && intakeFormConfig.find((item) => item.formType === EIntakeFormType.BASIC_INITIAL_INTAKE_FORM)
    );
    const showOtherBasicIntakeForm = !!(
        intakeFormConfig &&
        intakeFormConfig.find(
            (item) =>
                item.formType === EIntakeFormType.BASIC_FOLLOW_UP_INTAKE_FORM ||
                item.formType === EIntakeFormType.BASIC_PRESCRIPTION_REFILLS_INTAKE_FORM,
        )
    );
    const showSpecificIntakeForm = !!(
        intakeFormConfig && intakeFormConfig.find((item) => item.formType === EIntakeFormType.SPECIFIC_INTAKE_FORM)
    );
    const [homeInfo] = useProviderHomeInfo();
    // 只有真正的 PPV（后端 ppvProvider）才算 PPV；没有 vendor mapping 的 EHR Only / billing 起步用户不能再按「非 PPA」当成 PPV
    const isPPV = !!homeInfo?.ppvProvider;

    const [get] = UniprofileStepDataStore.useStore();
    const currentSpeciality = get('currentSpeciality');

    const [pendingInsuranceTableDataForMerge, setPendingInsuranceTableDataForMerge] =
        React.useState<ServerKlarityService>();

    const maxCashPayPrice = useMemo(() => {
        const items = pendingInsuranceTableDataForMerge?.serviceStateItems;
        if (!items || items.length === 0) return undefined;
        let max: number | undefined;
        items.forEach((item) => {
            if (item.cashPay && item.patientCost && item.patientCost > 0) {
                if (max === undefined || item.patientCost > max) {
                    max = item.patientCost;
                }
            }
        });
        return max;
    }, [pendingInsuranceTableDataForMerge]);
    const [isManualEditToInsuranceTable, setIsManualEditToInsuranceTable] = React.useState(false);

    const statesOption = useMemo(() => {
        if (isKiwiUser) {
            return allStates;
        }
        return isInit ? allStatesFromService : allowStates;
    }, [isKiwiUser, isInit, allStatesFromService, allowStates, allStates]);

    const isLaFireSpe = false; //LA_FIRE_SPE_NAME?.toLowerCase() === service?.specialtyName?.toLowerCase();

    const [currentEditInsuranceRowData, setCurrentEditInsuranceRowData] = React.useState<TInsuranceInput>();

    const [insuranceCarrierOptions, setInsuranceCarrierOptions] = React.useState<TInsuranceInput[]>([]);
    const [insuranceLoading, setInsuranceLoading] = React.useState(false);
    //add intake for Psychiatry, Counseling, Weight Loss, Skin Care, General
    const currentSpecialityName = currentSpeciality;
    if (currentSpecialityName) {
        ['Psychiatry', 'Counseling', 'Weight Loss', 'Skin Care', 'General'].forEach((item) => {
            if (currentSpecialityName.toLowerCase().includes(item.toLowerCase())) {
                showIntakeFormConfig = true;
            }
        });
    }

    const [insuranceTableData, setInsuranceTableData] = React.useState<
        Record<
            string,
            InsuranceSetting & {
                duration?: number;
                cashPrice?: number;
                insurancePay?: boolean;
                cashPay?: boolean;
            }
        >
    >();

    const insuranceTableRef = React.useRef<{
        getServerKlarityServiceData: () => ServerKlarityService;
    }>();

    const [pendingSaveData, setPendingSaveData] = React.useState<ServerKlarityService>();

    // 处理老数据，老数据中state的stateItem中，insurancePay或者cashPay 不存在，且不为布尔值,。
    // 那么需要遍历stateItem，里面的state，
    // insurancePay的话，如果不存在，且不为布尔值，那么去editValue的insurances字段里找，有没有同样state的数据。如果有，insurancePay就是true，否则就是false
    // cashPay比较特殊，遍历stateItem, 如果有cashPay字段，且为布尔值，那么cashPay = stateItem.cashPay，否则cashPay = false
    const handleOldData = (stateItem?: TServiceStateItem, insurances?: TInsuranceInput[]) => {
        const result = {
            cashPay: true,
            insurancePay: false,
        };
        if (stateItem) {
            // 没字段，或者是undefined，null的，属于老数据
            if (typeof stateItem.insurancePay !== 'boolean' && !stateItem.insurancePay) {
                result.insurancePay = !!insurances?.some((ins) => ins.state === stateItem.state);
            } else {
                result.insurancePay = !!stateItem.insurancePay;
            }
            let res = !!stateItem.cashPay;

            // 既没有cashPay，又没有insurancePay,那么至少得保留一种payment，这里保留cashPay
            if (!res && !result.insurancePay) {
                res = true;
            }

            result.cashPay = res;
        }

        return result;
    };

    useEffect(() => {
        if (homeInfo && !isEdit) {
            if (homeInfo.ppaProvider) {
                setPendingOpenPatientIntakeForms(false);
            } else {
                setPendingOpenPatientIntakeForms(true);
            }
        }
    }, [homeInfo, isEdit]);

    useEffect(() => {
        if (useInsuranceComponent) {
            if (editValue) {
                // 从editValue中提取insurance数据并转换为insuranceTableData格式
                const convertedData = states.reduce(
                    (acc, state) => {
                        const targetState = allStates?.find((item) => item.content === state || item.dictKey === state);
                        if (targetState) {
                            // 从editValue.serviceStateItems中找到对应state的数据
                            const stateItem = editValue.serviceStateItems?.find(
                                (item) => item.state === targetState.dictKey || item.state === targetState.content,
                            );
                            // 从editValue.insurances中找到对应state的保险数据
                            const stateInsurances =
                                editValue.insurances?.filter(
                                    (ins) => ins.state === targetState.dictKey || ins.state === targetState.content,
                                ) || [];

                            if (!stateItem) {
                                console.info({
                                    editValue: editValue.serviceStateItems,
                                    targetState,
                                });
                            }

                            // 将TInsuranceInput转换为CarrierSetting格式
                            const carriersMap = new Map<string, CarrierSetting>();
                            stateInsurances.forEach((insurance) => {
                                const carrierName = insurance.carrier;
                                if (!carriersMap.has(carrierName)) {
                                    carriersMap.set(carrierName, {
                                        name: carrierName,
                                        plans: [],
                                        otherPlans: '',
                                        commercialPayerId: insurance.commercialPayerId,
                                        governmentPayerId: insurance.governmentPayerId,
                                    });
                                }
                                const carrier = carriersMap.get(carrierName)!;
                                if (insurance.plan && !carrier.plans.includes(insurance.plan)) {
                                    carrier.plans.push(insurance.plan);
                                }
                                if (!carrier.commercialPayerId && insurance.commercialPayerId) {
                                    carrier.commercialPayerId = insurance.commercialPayerId;
                                }
                                if (!carrier.governmentPayerId && insurance.governmentPayerId) {
                                    carrier.governmentPayerId = insurance.governmentPayerId;
                                }
                            });

                            acc[targetState.dictKey] = {
                                // InsuranceSetting的基本结构
                                state: targetState.dictKey,
                                carriers: Array.from(carriersMap.values()),
                                otherCarriers: '', // 从editValue中可能没有这个字段，设为空字符串

                                // 额外的字段
                                duration: stateItem?.duration || 30,
                                cashPrice: stateItem?.patientCost || undefined,
                                insurancePay: handleOldData(stateItem, stateInsurances)?.insurancePay,
                                cashPay: handleOldData(stateItem, stateInsurances)?.cashPay,
                            };
                        }
                        return acc;
                    },
                    {} as Record<
                        string,
                        InsuranceSetting & {
                            duration?: number;
                            cashPrice?: number;
                            insurancePay?: boolean;
                            cashPay?: boolean;
                        }
                    >,
                );

                setInsuranceTableData(convertedData);
            } else {
                // setInsuranceTableData({});
            }
        }
    }, [editValue, states, servicePriceConfig, useInsuranceComponent, allStates]);

    const onlyInsurance = useMemo(() => {
        return isKiwiUser && pendingPaymentType.length === 1 && pendingPaymentType.includes(PAMENT_TYPES.insurance);
    }, [isKiwiUser, pendingPaymentType]);
    //const onlyInsurance = true;

    let canEditPrice = true;
    let targetDate = '';

    //console.log({ allStateConfigTypePriceData, stateContentMyEaringMap })

    const getPlansOptionsValue = (plans: string[], carrier: string) => {
        return plans
            .filter((e) => !!e)
            .map((item) => {
                if (item.indexOf(splitsymbol) > -1) {
                    return {
                        label: item,
                        value: item,
                    };
                }
                return {
                    label: `${carrier}${splitsymbol}${item}`,
                    value: `${carrier}${splitsymbol}${item}`,
                };
            });
    };

    const getCarrierOptions = (state: string) => {
        if (uniprofileInsuranceData) {
            const carriers = uniprofileInsuranceData.filter((item) => item.state === state);
            return carriers.map((item) => {
                return {
                    label: item.carrier,
                    value: item.carrier,
                };
            });
        }
        return [];
    };

    // const plansOptions = useMemo(() => {
    //     return getPlanOptions(states[0], states[0]);
    // }, [states]);

    const getPlanOptions = (state: string, stateContent: string) => {
        if (uniprofileInsuranceData) {
            const carriers = stateContentInsuranceCarrierMap[stateContent];
            if (carriers && carriers.length > 0) {
                const carriersInUniprofileData = uniprofileInsuranceData.filter((item) => item.state === state);

                if (carriersInUniprofileData.length > 0) {
                    const plans = [];

                    carriersInUniprofileData
                        .filter((item) => carriers.includes(item.carrier))
                        .forEach((item) => {
                            const options = getPlansOptionsValue(item.plans, item.carrier);
                            plans.push(options);
                        });

                    return plans.flat();
                }
            }
        }
        return [];
    };

    let showConsultationFree = false;
    const priceUpdateAt = editValue?.priceUpdateAt;
    if (priceUpdateAt) {
        try {
            const updateTime = BigInt(new Date(priceUpdateAt).getTime());
            const nowTime = BigInt(new Date().getTime());
            targetDate = dayjs(priceUpdateAt).add(30, 'day').format('MM/DD/YYYY');
            canEditPrice = nowTime - updateTime > 30 * 24 * 60 * 60 * 1000;
        } catch (e) {
            console.error(e);
        }
    }
    //canEditPrice = true;

    if (isConsultation) {
        if (!isEdit) {
            showConsultationFree = true;
        } else if (isEdit && editValue) {
            let hasNewAddstate = false;

            const hasZeroPrice = editValue?.serviceStateItems?.find((item) => item.earning === 0);
            if (hasZeroPrice) {
                showConsultationFree = true;
            }
            const editValueStateContent: string[] = editValue.serviceStateItems?.map((item) => {
                const target = (allStates as ServerMeta[])?.find((st: ServerMeta) => {
                    return st.content === item.state || st.dictKey === item.state;
                });
                return `${target?.content}`;
            });
            states?.forEach((st: string) => {
                if (!editValueStateContent.includes(st)) {
                    hasNewAddstate = true;
                }
            });
            if (hasNewAddstate) {
                showConsultationFree = true;
            }
        }
    }

    let allHasSelectState = true;
    let pendingPgiInfoStateLength = 0;
    pendingPgiInfo.forEach((info: PigInfo) => {
        pendingPgiInfoStateLength += info?.states?.length || 0;
        if (!info.states || info.states.length === 0) {
            allHasSelectState = false;
        }
    });
    const allStateSeted = pendingPgiInfoStateLength === states?.length;

    const checkPendingServiceTypeName = async () => {
        if (editValue) {
            if (pendingCustomizeName === editValue.customizedServiceName) {
                setNameIsExistInServerError(false);
                return;
            }
            if (!pendingCustomizeName && !editValue.customizedServiceName) {
                setNameIsExistInServerError(false);
            }
        }
        // not need
        // const result = await checkServiceTypeName({
        //     customizedServiceName: pendingCustomizeName,
        //     serviceSpecialtyId: service?.id!,
        //     serviceTypeId: serviceTypeTemplate?.id!,
        // });
        // if (!result.error) {
        //     if (result?.data.data) {
        //         setNameIsExistInServerError(true);
        //         return;
        //     }
        // }
        // setNameIsExistInServerError(false);
    };

    React.useEffect(() => {
        if (!editValue) {
            checkPendingServiceTypeName();
        } else {
            setNameIsExistInServerError(false);
        }
    }, [editValue]);

    React.useEffect(() => {
        onNameIsExistedError?.(nameIsExistInServerError);
    }, [nameIsExistInServerError]);

    let keysStr: string = '';
    if (allStateConfigTypePriceData) {
        keysStr = Object.keys(allStateConfigTypePriceData)?.join(',');
    }

    React.useEffect(() => {
        if (allowStates && allStateConfigTypePriceData && Object.keys(allStateConfigTypePriceData).length > 0) {
            const allAllowStateContent = allowStates.map((item) => item.content);
            const allConfigStateContent = Object.keys(allStateConfigTypePriceData);
            const isSameArray = isSameStringArray(allAllowStateContent, allConfigStateContent);

            if (Object.keys(stateContentMyEaringMap).length < allowStates.length) {
                const _stateContentMyEaringMap: Record<string, number> = {};
                allowStates.forEach((st: ServerMeta) => {
                    if (
                        klarityTemplate &&
                        KLAIRTY_TEMPLATE_PRICE_MAP[klarityTemplate as keyof typeof KLAIRTY_TEMPLATE_PRICE_MAP]
                    ) {
                        _stateContentMyEaringMap[st.content!] =
                            KLAIRTY_TEMPLATE_PRICE_MAP[
                                klarityTemplate as keyof typeof KLAIRTY_TEMPLATE_PRICE_MAP
                            ].myEarning;
                    } else {
                        const targetPrice: TKlarityPrice =
                            allStateConfigTypePriceData[st.content]?.[serviceTypeTemplate?.serviceType!];
                        const oldPrice =
                            stateContentMyEaringMap && st?.content ? stateContentMyEaringMap[st.content] : undefined;
                        let hasOldPrice = false;
                        if (oldPrice !== null && oldPrice !== undefined) {
                            hasOldPrice = true;
                        }
                        _stateContentMyEaringMap[st.content!] = hasOldPrice ? oldPrice! : targetPrice?.krc || 0;
                    }
                });
                setStateContentMyEaringMap(_stateContentMyEaringMap);
            }
        }
    }, [
        allowStates,
        allStateConfigTypePriceData,
        stateContentMyEaringMap,
        serviceTypeTemplate,
        keysStr,
        klarityTemplate,
    ]);

    React.useEffect(() => {
        if (!isInit || isEdit) {
            return;
        }
        if (states && allStateConfigTypePriceData && Object.keys(allStateConfigTypePriceData).length > 0) {
            const allConfigStateContent = Object.keys(allStateConfigTypePriceData);
            const isSameArray = isSameStringArray(states, allConfigStateContent);

            if (isSameArray) {
                const _stateContentMyEaringMap: Record<string, number> = {};
                states.forEach((st: string) => {
                    if (
                        klarityTemplate &&
                        KLAIRTY_TEMPLATE_PRICE_MAP[klarityTemplate as keyof typeof KLAIRTY_TEMPLATE_PRICE_MAP]
                    ) {
                        _stateContentMyEaringMap[st!] =
                            KLAIRTY_TEMPLATE_PRICE_MAP[
                                klarityTemplate as keyof typeof KLAIRTY_TEMPLATE_PRICE_MAP
                            ].myEarning;
                    }
                    // else {
                    //     const targetPrice: TKlarityPrice = allStateConfigTypePriceData[st]?.[serviceTypeTemplate?.serviceType!];
                    //     _stateContentMyEaringMap[st!] = targetPrice?.krc || 0;
                    // }
                });
                setStateContentMyEaringMap((pre) => {
                    return { ...pre, ..._stateContentMyEaringMap };
                });
            }
        }
    }, [isInit, states, allStateConfigTypePriceData, allStates, isEdit, klarityTemplate]);

    // useEffect(() => {
    //     if (isKiwiUser && provider) {
    //         const _pendingPaymentType: number[] = [];
    //         if (editValue?.cashPay) {
    //             _pendingPaymentType.push(PAMENT_TYPES.cash);
    //         }
    //         if (editValue?.insurancePay) {
    //             _pendingPaymentType.push(PAMENT_TYPES.insurance);
    //         }
    //         setPendingPaymentType(_pendingPaymentType);
    //     }
    // }, [])

    React.useEffect(() => {
        const _allowStates = isKiwiUser ? (allStates as ServerMeta[]) : allowStates;

        if (_allowStates && editValue && states.length === 0) {
            //allow state is get from current value
            const currentEditItemStateContent = editValue.serviceStateItems?.map((item) => item.state);
            const currentEditItemState = _allowStates.filter(
                (item) =>
                    currentEditItemStateContent?.includes(item.dictKey) ||
                    currentEditItemStateContent?.includes(item.content),
            );
            const isInitVisitServer = editValue.serviceType === EServiceType.INIT;
            setInitStatesFromEdit(
                (isInitVisitServer ? _allowStates : currentEditItemState)?.map((item) => item.content),
            );
            const isFire = service?.specialtyName?.toLowerCase() === LA_FIRE_SPE_NAME?.toLowerCase();
            if (isFire) {
                setStates(
                    _allowStates.filter((item) => item.dictKey?.toLowerCase() === 'ca').map((item) => item.content),
                );
            } else {
                setStates((isInitVisitServer ? _allowStates : currentEditItemState)?.map((item) => item.content));
            }

            setPendingCustomizeName(editValue?.customizedServiceName || '');
            setPendingDescription(editValue?.description || '');
            setMedicationList(editValue?.medications || []);
            setPendingOpenPatientIntakeForms(editValue?.intakeFormFlag || false);
            if (editValue?.allowControlledMedRefill) {
                setPendingControlledMedicationRefillsType(
                    editValue?.allowControlledMedRefill
                        ? CONTROLED_MEDICATION_REFILLS_TYPES.yes
                        : CONTROLED_MEDICATION_REFILLS_TYPES.no,
                );
                setPendingControlledMedicationRefillsMaxAmount(editValue?.maxControlledMedAsyncRefills || undefined);
            }
            //use edit value
            //pgiLmitExtraOption
            if (editValue.patientGroupLimitations && editValue.patientGroupLimitations.length > 0) {
                const allLimitStr: string[] = [];
                editValue.patientGroupLimitations.forEach((item) => {
                    item.limitation?.forEach((str: string) => {
                        if (!allLimitStr.includes(str)) {
                            allLimitStr.push(str);
                        }
                    });
                });

                const _pgiLmitOption =
                    serviceTypeTemplate?.klarityServiceTypeLimitationList?.map((item) => {
                        return {
                            label: item.limitation,
                            value: `${item.limitation}`,
                        };
                    }) || [];
                const filtered = allLimitStr.filter((str: string) => {
                    const exist = _pgiLmitOption?.find((item) => {
                        return item.label === str || item.value === str;
                    });
                    return !exist;
                });
                setPgiLmitExtraOption(
                    filtered?.map((str: string) => {
                        return {
                            label: str,
                            value: str,
                        };
                    }),
                );
            }

            //address

            const _stateAddressIdsMap: Record<string, string[]> = {};
            const _stateContactTypeMap: Record<string, EContactType[]> = {};
            _allowStates.forEach((state: ServerMeta) => {
                _stateContactTypeMap[state.content] = [];
                const targetSeviceState: TServiceStateItem | undefined = editValue?.serviceStateItems?.find(
                    (item: TServiceStateItem) => {
                        return item.state === state.dictKey || item.state === state.content;
                    },
                );
                if (targetSeviceState && targetSeviceState.teleHealth) {
                    _stateContactTypeMap[state.content].push(EContactType.TELE_HEALTH);
                }
                if (targetSeviceState && targetSeviceState.inPerson) {
                    _stateContactTypeMap[state.content].push(EContactType.IN_PERSON);
                }
                if (_stateContactTypeMap[state.content].includes(EContactType.IN_PERSON)) {
                    _stateAddressIdsMap[state.content] = targetSeviceState?.practiceAddressIds || [];
                } else {
                    _stateAddressIdsMap[state.content] = [];
                }
            });
            setStateAddressIdsMap(_stateAddressIdsMap);
            setStateContactTypeMap(_stateContactTypeMap);

            const _stateTelehealthPosMap: Record<string, string> = {};
            const _stateInPersonPosMap: Record<string, string> = {};
            const _stateTelehealthModifierMap: Record<string, string> = {};
            const _stateInPersonModifierMap: Record<string, string> = {};
            _allowStates.forEach((state: ServerMeta) => {
                const targetSeviceState: TServiceStateItem | undefined = editValue?.serviceStateItems?.find(
                    (item: TServiceStateItem) => {
                        return item.state === state.dictKey || item.state === state.content;
                    },
                );
                const contactTypes = _stateContactTypeMap[state.content] || [];
                const isTeleOn = contactTypes.includes(EContactType.TELE_HEALTH);
                const isInPersonOn = contactTypes.includes(EContactType.IN_PERSON);
                if (targetSeviceState?.telehealthPosCode) {
                    _stateTelehealthPosMap[state.content] = targetSeviceState.telehealthPosCode;
                } else if (isTeleOn) {
                    _stateTelehealthPosMap[state.content] = '10';
                }
                if (targetSeviceState?.inPersonPosCode) {
                    _stateInPersonPosMap[state.content] = targetSeviceState.inPersonPosCode;
                } else if (isInPersonOn) {
                    _stateInPersonPosMap[state.content] = '11';
                }
                if (targetSeviceState?.telehealthModifierCode) {
                    _stateTelehealthModifierMap[state.content] = targetSeviceState.telehealthModifierCode;
                } else if (isTeleOn) {
                    _stateTelehealthModifierMap[state.content] = '95';
                }
                if (targetSeviceState?.inPersonModifierCode) {
                    _stateInPersonModifierMap[state.content] = targetSeviceState.inPersonModifierCode;
                }
            });
            setStateTelehealthPosMap(_stateTelehealthPosMap);
            setStateInPersonPosMap(_stateInPersonPosMap);
            setStateTelehealthModifierMap(_stateTelehealthModifierMap);
            setStateInPersonModifierMap(_stateInPersonModifierMap);

            if (editValue?.patientGroupLimitations && editValue?.patientGroupLimitations?.length > 0) {
                setPgiIsOpen(true);
                //pendingPgiInfo.
                const _pendingPgiInfo: PigInfo[] = [];
                editValue?.patientGroupLimitations.forEach((item: TPatientGroupLimitation) => {
                    const contactType: EContactType[] = [];
                    if (item.appliedInPerson) {
                        contactType.push(EContactType.IN_PERSON);
                    }
                    if (item.appliedTeleHealth) {
                        contactType.push(EContactType.TELE_HEALTH);
                    }
                    const stateKeys = item.stateGroup || [];
                    const pigStates = allowStates?.filter((st: ServerMeta) => {
                        return stateKeys.includes(st.dictKey) || stateKeys.includes(st.content);
                    });
                    const add: PigInfo = {
                        states: pigStates,
                        accept: item.patientGroup || [],
                        contactType,
                        limitations: item.limitation || [],
                    };
                    _pendingPgiInfo.push(add);
                });
                setPendingPgiInfo(_pendingPgiInfo);
            }

            if (editValue?.serviceStateItems) {
                const _stateContentMyEaringMap: Record<string, number> = {};
                const _stateContentDurationMap: Record<string, number> = {};
                const _stateContentShippingFeeMap: Record<string, number> = {};

                const _stateContentPatientCostMap: Record<string, number> = {};
                const _stateContentSuperBillSupportMap: Record<string, boolean> = {};
                const _stateContentPriorAuthorizationSupportMap: Record<string, boolean> = {};
                _allowStates.forEach((st: ServerMeta) => {
                    const targetItem: TServiceStateItem | undefined = editValue?.serviceStateItems?.find((item) => {
                        return item.state === st.content || item.state === st.dictKey;
                    });
                    _stateContentMyEaringMap[st.content!] = targetItem?.earning || 0;
                    _stateContentDurationMap[st.content!] =
                        targetItem?.duration !== null && targetItem?.duration !== undefined ? targetItem?.duration : 30;
                    _stateContentShippingFeeMap[st.content!] = targetItem?.shipmentFee || 0;
                    if (isKiwiUser) {
                        _stateContentPatientCostMap[st.content!] = targetItem?.patientCost || 0;
                        _stateContentSuperBillSupportMap[st.content!] = targetItem?.superBillSupport || false;
                        _stateContentPriorAuthorizationSupportMap[st.content!] =
                            targetItem?.priorAuthorizationSupport || false;
                    }
                });
                setStateContentMyEaringMap(_stateContentMyEaringMap);
                setStateContentDurationMap(_stateContentDurationMap);
                setStateContentShippingFeeMap(_stateContentShippingFeeMap);
                if (isKiwiUser) {
                    setStateContentPatientCostMap(_stateContentPatientCostMap);
                    setStateContentSuperBillSupportMap(_stateContentSuperBillSupportMap);
                    setStateContentPriorAuthorizationSupportMap(_stateContentPriorAuthorizationSupportMap);
                    setStateContentInsuranceDurationMap(_stateContentDurationMap);
                }
            }

            if (isKiwiUser) {
                if (editValue?.insurances) {
                    const _stateContentInsuranceCarrierMap: Record<string, string[]> = {};
                    const _stateContentInsurancePlanMap: Record<string, string[]> = {};

                    _allowStates.forEach((st: ServerMeta) => {
                        const targetItem = editValue?.insurances?.filter((item) => {
                            return item.state === st.content || item.state === st.dictKey;
                        });
                        if (targetItem) {
                            _stateContentInsuranceCarrierMap[st.content!] = Array.from(
                                new Set(targetItem.map((item) => item.carrier)),
                            );
                            targetItem.forEach((item) => {
                                const { carrier, plan } = item;
                                // const planobj = {
                                //     plan,
                                //     carrier,
                                // };

                                // 初始化 state 对象
                                if (!_stateContentInsurancePlanMap[st.content!]) {
                                    _stateContentInsurancePlanMap[st.content!] = {};
                                }

                                // 初始化 carrier 对应的 plan 数组
                                if (!_stateContentInsurancePlanMap[st.content!][carrier]) {
                                    _stateContentInsurancePlanMap[st.content!][carrier] = [];
                                }

                                // 添加 plan，避免重复
                                if (!_stateContentInsurancePlanMap[st.content!][carrier].includes(plan)) {
                                    _stateContentInsurancePlanMap[st.content!][carrier].push(plan);
                                }
                            });
                            // const plans = [];
                            // targetItem.forEach((item) => {
                            //     const { carrier, plan } = item;

                            //     if (_stateContentInsurancePlanMap[st.content!]) {
                            //         if (!_stateContentInsurancePlanMap[st.content!][carrier]) {
                            //             _stateContentInsurancePlanMap[st.content!][carrier] = [];
                            //         }
                            //     } else {
                            //         _stateContentInsurancePlanMap[st.content!] = { [carrier]: [] };
                            //     }
                            // });

                            // const carrierWitnSameState = targetItem.filter((item) => {
                            //     return item.state === st.content || item.state === st.dictKey;
                            // });
                            // _stateContentInsurancePlanMap[st.content!] = plans;
                        }
                    });

                    setStateContentInsuranceCarrierMap(_stateContentInsuranceCarrierMap);
                    setStateContentInsurancePlanMap(_stateContentInsurancePlanMap);
                }
            }

            if (editValue?.medications && editValue?.medications?.length > 0) {
                setDefaultMedicationList(editValue.medications);
            }

            return;
        }

        if (!editValue && klarityTemplate === WEIGHT_LOSS_15_MINS_TEMPLATE) {
            setPendingCustomizeName('Consultation and Prescription');
        }

        if (_allowStates && serviceTypeTemplateValue) {
            const _stateContentDurationMap: Record<string, number> = {};
            _allowStates.forEach((st: ServerMeta) => {
                _stateContentDurationMap[st.content!] =
                    serviceTypeTemplateValue?.duration || serviceTypeTemplate?.defaultDuration || 30;
            });
            setStateContentDurationMap(_stateContentDurationMap);
            setStateContentInsuranceDurationMap(_stateContentDurationMap);
        }
    }, [allowStates, serviceTypeTemplateValue, serviceTypeTemplate, editValue, isKiwiUser, allStates]);

    // 一开始的时候在allowStates里，stateFromInitVisit是空的，
    // 之后states selector每次change，都会更新到stateFromInitVisit里， 而allowStates不会随着变动
    const initialVisitSelectedStates = useMemo(() => {
        if (!stateFromInitVisit || stateFromInitVisit.length === 0) {
            return allowStates?.map((e) => e.content);
        }
        return stateFromInitVisit.map((e) => e.content);
    }, [allowStates, stateFromInitVisit]);

    React.useEffect(() => {
        if (serviceTypeTemplateValue && !editValue) {
            let _pendingPgiInfo = [...pendingPgiInfo];
            if (isLaFireSpe) {
                _pendingPgiInfo = [
                    {
                        states: allowStates?.filter((item) => item.dictKey?.toLowerCase() === 'ca') || [],
                        accept: serviceTypeTemplateValue.patientGroupIds?.split(',') || [],
                        contactType: [EContactType.TELE_HEALTH],
                        limitations: serviceTypeTemplateValue.limitationIds?.split(',') || [],
                    },
                ];
            }
            const targetStates: ServerMeta[] | undefined = initialVisitSelectedStates?.map((e) =>
                allStates?.find((item) => item.content === e || item.dictKey === e),
            );

            _pendingPgiInfo.forEach((item) => {
                const patientGroupIds = serviceTypeTemplateValue.patientGroupIds?.split(',');
                const limitationIds = serviceTypeTemplateValue.limitationIds?.split(',') || [];
                item.accept =
                    serviceTypeTemplate?.klarityServiceTypePatientGroupList
                        ?.filter((i) => {
                            return patientGroupIds.includes(`${i.id}`);
                        })
                        ?.map((i) => i.patientGroup) || [];
                item.limitations =
                    serviceTypeTemplate?.klarityServiceTypeLimitationList
                        ?.filter((i) => {
                            return limitationIds.includes(`${i.id}`);
                        })
                        ?.map((i) => i.limitation) || [];
                item.states = targetStates;
            });
            setPendingPgiInfo(_pendingPgiInfo);
        }
    }, [
        serviceTypeTemplateValue,
        editValue,
        initialVisitSelectedStates,
        isLaFireSpe,
        allowStates,
        serviceTypeTemplate,
        allStates,
    ]);

    React.useEffect(() => {
        const _allowStates = isKiwiUser ? (allStates as ServerMeta[]) : allowStates;
        if (!hasInitState && _allowStates && _allowStates.length > 0 && !isEdit) {
            if (isLaFireSpe) {
                setStates(
                    allowStates.filter((item) => item.dictKey?.toLowerCase() === 'ca').map((item) => item.content),
                );
            } else {
                setStates(_allowStates.map((item) => item.content));
            }
            setHasInitState(true);
        }
    }, [allowStates, hasInitState, isEdit, isLaFireSpe, allStates, isKiwiUser]);

    // 新增数据初始化
    React.useEffect(() => {
        const _allowStates = isKiwiUser ? (allStates as ServerMeta[]) : allowStates;
        const _addressOptions: PracitceAddressForm[] = provider?.practice?.addressList || [];
        if (!isEdit && _allowStates && _allowStates.length > 0) {
            if (_addressOptions.length > 0) {
                const _stateAddressIdsMap: Record<string, string[]> = {};
                const _stateContactTypeMap: Record<string, EContactType[]> = {};
                // 模板默认开启的 tele-health 不经过 onTeleChange，要在这里同步补上默认 POS / modifier，
                // 否则用户不动开关直接保存，telehealth_pos_code / telehealth_modifier_code 会存成 NULL
                const _teleDefaultPosMap: Record<string, string> = {};
                const _teleDefaultModifierMap: Record<string, string> = {};
                _allowStates.forEach((state: ServerMeta) => {
                    _stateContactTypeMap[state.content] = [];
                    if (serviceTypeTemplateValue?.teleHealth) {
                        _stateContactTypeMap[state.content].push(EContactType.TELE_HEALTH);
                        _teleDefaultPosMap[state.content] = '10';
                        _teleDefaultModifierMap[state.content] = '95';
                    }
                    // if (serviceTypeTemplateValue?.inPerson) {
                    //     _stateContactTypeMap[state.content].push(EContactType.IN_PERSON);
                    // }
                    if (_stateContactTypeMap[state.content].includes(EContactType.IN_PERSON)) {
                        const addData = _addressOptions
                            .filter((add) => {
                                return (
                                    (add.practiceState?.toLowerCase() === state.dictKey.toLowerCase() ||
                                        add.practiceState?.toLowerCase() === state.content.toLowerCase()) &&
                                    [AddressPublicType.INVITATION, AddressPublicType.WALK_IN].includes(add.publicType)
                                );
                            })
                            ?.map((add) => `${add.id}`);
                        _stateAddressIdsMap[state.content] = addData;
                    } else {
                        _stateAddressIdsMap[state.content] = [];
                    }
                });
                setStateAddressIdsMap(_stateAddressIdsMap);
                setStateContactTypeMap(_stateContactTypeMap);
                setStateTelehealthPosMap((prev) => ({ ..._teleDefaultPosMap, ...prev }));
                setStateTelehealthModifierMap((prev) => ({ ..._teleDefaultModifierMap, ...prev }));
            }

            const _stateContentPriorAuthorizationSupportMap: Record<string, boolean> = {};
            const _stateContentSuperBillSupportMap: Record<string, boolean> = {};
            _allowStates.forEach((st: ServerMeta) => {
                _stateContentPriorAuthorizationSupportMap[st.content!] = true;
                _stateContentSuperBillSupportMap[st.content!] = true;
            });
            setStateContentPriorAuthorizationSupportMap(_stateContentPriorAuthorizationSupportMap);
            setStateContentSuperBillSupportMap(_stateContentSuperBillSupportMap);
        }
    }, [allowStates, provider, isEdit, allStates, isKiwiUser]);

    React.useEffect(() => {
        const data: Partial<ServerKlarityService> = {
            serviceSpecialtyName: service?.specialtyName,
            serviceSpecialtyId: `${service?.id}`,
            serviceTypeId: serviceTypeTemplate?.id,
            serviceType: serviceTypeTemplate?.serviceType,
            providerId: providerId && isOps ? providerId : getUserId(),
            customizedServiceName: nameIsExistInServerError ? '' : pendingCustomizeName,
            description: pendingDescription,
            serviceStateItems: [],
            patientGroupLimitations: [],
            insurances: [],
            intakeFormFlag: !!pendingOpenPatientIntakeForms,
        };
        if (medicationList) {
            data.medications = medicationList;
        }
        if (isEdit) {
            data.serviceId = serviceId;
        }

        const insurances: TInsurance[] = [];
        states?.forEach((state) => {
            const addressIds = stateAddressIdsMap[state];
            const contactTypes = stateContactTypeMap[state];
            const duration =
                isKiwiUser && onlyInsurance ? stateContentInsuranceDurationMap[state] : stateContentDurationMap[state];
            const myEarning = stateContentMyEaringMap[state];
            const shippingFee = stateContentShippingFeeMap[state];
            const mmu = allStateConfigTypePriceData?.[state]?.[serviceTypeTemplate?.serviceType!]?.mmu || 0;
            let pf = allStateConfigTypePriceData?.[state]?.[serviceTypeTemplate?.serviceType!]?.pf || 0;
            if (isConsultation && pf === 0 && myEarning > consultationOverPrice) {
                pf = allStateConfigTypePriceData?.[state]?.[EServiceType.INIT]?.pf || 0;
            }

            const total = myEarning + mmu + pf;

            const targetState: ServerMeta | undefined = (isKiwiUser ? allStates : allowStates)?.find(
                (item) => item.content === state || item.dictKey === state,
            );
            if (isKiwiUser && pendingPaymentType.includes(PAMENT_TYPES.insurance)) {
                const carriersMap = stateContentInsuranceCarrierMap[state];
                const plansMap = stateContentInsurancePlanMap[state];
                if (carriersMap && carriersMap.length > 0) {
                    carriersMap.forEach((carrier) => {
                        const plans = plansMap[carrier];
                        if (plans && plans.length > 0) {
                            plans.forEach((plan) => {
                                let planValue = plan;

                                if (plan.indexOf(splitsymbol) > -1) {
                                    planValue = plan.split(splitsymbol)[1];
                                }

                                insurances.push({
                                    carrier,
                                    plan: planValue,
                                    state: targetState?.dictKey!,
                                });
                            });
                        } else {
                            insurances.push({
                                carrier,
                                plan: '',
                                state: targetState?.dictKey!,
                            });
                        }
                    });
                }
            }

            const serviceStateItem: TServiceStateItem = {
                //serviceId: service?.id!,
                state: targetState?.dictKey!, //'CA',
                duration,
                earning: myEarning,
                shipmentFee: shippingFee || 0,
                marketingMarkup: mmu,
                platformFee: pf,
                patientCost: Number.isNaN(total) ? 0 : total,
                practiceAddressIds: addressIds?.map((id) => `${id}`) || [],
                teleHealth: !!contactTypes?.includes(EContactType.TELE_HEALTH),
                inPerson: !!contactTypes?.includes(EContactType.IN_PERSON),
                telehealthPosCode: stateTelehealthPosMap[state] || undefined,
                inPersonPosCode: stateInPersonPosMap[state] || undefined,
                telehealthModifierCode: stateTelehealthModifierMap[state] || undefined,
                inPersonModifierCode: stateInPersonModifierMap[state] || undefined,
            };
            if (isLaFireSpe) {
                serviceStateItem.marketingMarkup = 0;
                serviceStateItem.earning = LA_FIRE_SERVICE_PRICE;
                serviceStateItem.shipmentFee = 0;
                serviceStateItem.platformFee = 0;
                serviceStateItem.patientCost = LA_FIRE_SERVICE_PRICE;
                serviceStateItem.teleHealth = true;
                serviceStateItem.inPerson = false;
            }
            if (isKiwiUser) {
                const patientCost = stateContentPatientCostMap[state];
                serviceStateItem.superBillSupport = !!stateContentSuperBillSupportMap[state];
                serviceStateItem.priorAuthorizationSupport = !!stateContentPriorAuthorizationSupportMap[state];
                serviceStateItem.patientCost = pendingPaymentType.includes(PAMENT_TYPES.cash) ? patientCost : 0;

                data.cashPay = pendingPaymentType.includes(PAMENT_TYPES.cash);
                data.insurancePay = pendingPaymentType.includes(PAMENT_TYPES.insurance);
                data.insurances = insurances;
            }

            if (useInsuranceComponent) {
                const currentState = pendingInsuranceTableDataForMerge?.serviceStateItems?.find(
                    (item) => item.state === targetState?.dictKey,
                );

                serviceStateItem.patientCost = currentState?.patientCost;
                serviceStateItem.duration = currentState?.duration || duration;
                serviceStateItem.superBillSupport = currentState?.superBillSupport;
                serviceStateItem.priorAuthorizationSupport = currentState?.priorAuthorizationSupport;
                // if (paymentMethodName === INSURANCE_TYPE_CASH_AND_INSURANCE) {
                // serviceStateItem.cashPay = currentState?.cashPay;
                // serviceStateItem.insurancePay = currentState?.insurancePay;
                // }
                serviceStateItem.cashPay = currentState?.cashPay;
                serviceStateItem.insurancePay = currentState?.insurancePay;
                if (pendingControlledMedicationRefillsType) {
                    serviceStateItem.allowControlledMedRefill = !!(
                        pendingControlledMedicationRefillsType === CONTROLED_MEDICATION_REFILLS_TYPES.yes
                    );
                    serviceStateItem.maxControlledMedAsyncRefills = pendingControlledMedicationRefillsMaxAmount;
                } else {
                    serviceStateItem.allowControlledMedRefill = undefined;
                }
                // serviceStateItem.cashPay = pendingPaymentType.includes(PAMENT_TYPES.cash);
                // serviceStateItem.insurancePay = pendingPaymentType.includes(PAMENT_TYPES.insurance);
                data.insurances = pendingInsuranceTableDataForMerge?.insurances;
                data.cashPay = pendingPaymentType.includes(PAMENT_TYPES.cash);
                data.insurancePay = pendingPaymentType.includes(PAMENT_TYPES.insurance);
            }
            data.serviceStateItems?.push(serviceStateItem);

            if (klarityTemplate) {
                data.klarityTemplate = klarityTemplate;
            }
        });

        pendingPgiInfo.forEach((item: PigInfo) => {
            const selectState = allowStates?.filter((state) => {
                return item.states?.find((st) => st?.content === state?.content || st?.dictKey === state?.content);
            });
            if (selectState && selectState.length > 0) {
                const patientGroupLimitation: TPatientGroupLimitation = {
                    //serviceId: service?.id!,
                    stateGroup: selectState?.map((st) => st.dictKey!) || [],
                    patientGroup: item?.accept?.filter((val) => val !== 'all').map((val) => `${val}`) || [],
                    limitation: item?.limitations?.map((val) => `${val}`) || [],
                    appliedTeleHealth: !!item.contactType?.includes(EContactType.TELE_HEALTH),
                    appliedInPerson: !!item.contactType?.includes(EContactType.IN_PERSON),
                };
                data.patientGroupLimitations?.push(patientGroupLimitation);
            }
        });
        data.cpts = pendingCptCodes;
        setPendingSaveData(data as ServerKlarityService);
        onServiceTypeInfoUpdate?.(data as ServerKlarityService);
    }, [
        pendingCptCodes,
        pendingInsuranceTableDataForMerge,
        isEdit,
        klarityTemplate,
        serviceId,
        useInsuranceComponent,
        nameIsExistInServerError,
        pendingCustomizeName,
        pendingDescription,
        serviceTypeTemplate,
        serviceTypeTemplateValue,
        service?.specialtyName,
        service?.id,
        states,
        stateAddressIdsMap,
        stateContactTypeMap,
        stateTelehealthPosMap,
        stateInPersonPosMap,
        stateTelehealthModifierMap,
        stateInPersonModifierMap,
        stateContentMyEaringMap,
        pendingPgiInfo,
        allStateConfigTypePriceData,
        allowStates,
        stateContentDurationMap,
        medicationList,
        stateContentShippingFeeMap,
        stateContentInsuranceCarrierMap,
        stateContentSuperBillSupportMap,
        stateContentPriorAuthorizationSupportMap,
        pendingPaymentType,
        stateContentInsurancePlanMap,
        isKiwiUser,
        stateContentPatientCostMap,
        isOps,
        providerId,
        stateContentInsuranceDurationMap,
        onlyInsurance,
        allStates,
        pendingOpenPatientIntakeForms,
        pendingControlledMedicationRefillsType,
        pendingControlledMedicationRefillsMaxAmount,
    ]);

    const onAddressChange = (state: ServerMeta, addressIds: string[]) => {
        const _stateAddressIdsMap = { ...stateAddressIdsMap };
        _stateAddressIdsMap[state.content] = addressIds;
        setStateAddressIdsMap(_stateAddressIdsMap);
    };

    const onTeleChange = (state: ServerMeta, checked: boolean) => {
        const _stateContactTypeMap = { ...stateContactTypeMap };
        const current = _stateContactTypeMap[state.content] || [];
        if (checked && !current.includes(EContactType.TELE_HEALTH)) {
            current.push(EContactType.TELE_HEALTH);
            _stateContactTypeMap[state.content] = [...current];
            if (!stateTelehealthPosMap[state.content]) {
                setStateTelehealthPosMap((prev) => ({ ...prev, [state.content]: '10' }));
            }
            if (!stateTelehealthModifierMap[state.content]) {
                setStateTelehealthModifierMap((prev) => ({ ...prev, [state.content]: '95' }));
            }
        } else if (!checked) {
            _stateContactTypeMap[state.content] = current.filter((item) => item !== EContactType.TELE_HEALTH);
        }
        setStateContactTypeMap(_stateContactTypeMap);
    };

    const onInPersonChange = (state: ServerMeta, checked: boolean) => {
        const _stateContactTypeMap = { ...stateContactTypeMap };
        const current = _stateContactTypeMap[state.content] || [];
        if (checked && !current.includes(EContactType.IN_PERSON)) {
            current.push(EContactType.IN_PERSON);
            if (!stateInPersonPosMap[state.content]) {
                setStateInPersonPosMap((prev) => ({ ...prev, [state.content]: '11' }));
            }
        } else if (!checked) {
            _stateContactTypeMap[state.content] = current.filter((item) => item !== EContactType.IN_PERSON);
        }
        setStateContactTypeMap(_stateContactTypeMap);
    };

    const onTelehealthPosChange = (state: ServerMeta, value: string) => {
        setStateTelehealthPosMap((prev) => ({ ...prev, [state.content]: value }));
    };

    const onInPersonPosChange = (state: ServerMeta, value: string) => {
        setStateInPersonPosMap((prev) => ({ ...prev, [state.content]: value }));
    };

    const onTelehealthModifierChange = (state: ServerMeta, value: string) => {
        setStateTelehealthModifierMap((prev) => ({ ...prev, [state.content]: value }));
    };

    const onInPersonModifierChange = (state: ServerMeta, value: string) => {
        setStateInPersonModifierMap((prev) => ({ ...prev, [state.content]: value }));
    };

    const onPigStateChange = (inx: number, val: ServerMeta[]) => {
        const _pendingPgiInfo = [...pendingPgiInfo];
        if (_pendingPgiInfo.length > inx) {
            _pendingPgiInfo[inx].states = val;
        }
        setPendingPgiInfo(_pendingPgiInfo);
    };

    const onPigContactTypeChange = (inx: number, val: EContactType[]) => {
        const _pendingPgiInfo = [...pendingPgiInfo];
        if (_pendingPgiInfo.length > inx) {
            _pendingPgiInfo[inx].contactType = val;
        }
        setPendingPgiInfo(_pendingPgiInfo);
    };

    const onPigAcceptChange = (inx: number, val: string[]) => {
        const _pendingPgiInfo = [...pendingPgiInfo];
        if (_pendingPgiInfo.length > inx) {
            _pendingPgiInfo[inx].accept = val;
        }
        setPendingPgiInfo(_pendingPgiInfo);
    };

    const onPigLimitChange = (inx: number, val: string[]) => {
        const _pendingPgiInfo = [...pendingPgiInfo];
        if (_pendingPgiInfo.length > inx) {
            _pendingPgiInfo[inx].limitations = val;
        }
        setPendingPgiInfo(_pendingPgiInfo);
    };

    const onPigNewLimitChange = (inx: number, val: string) => {
        const _pendingPgiInfo = [...pendingPgiInfo];
        if (_pendingPgiInfo.length > inx) {
            _pendingPgiInfo[inx].pendingNewLimit = val;
        }
        setPendingPgiInfo(_pendingPgiInfo);
    };

    const onPigNewLimitChangeConfirm = (inx: number) => {
        const _pendingPgiInfo = [...pendingPgiInfo];

        if (_pendingPgiInfo.length > inx) {
            _pendingPgiInfo[inx].isAddingLimit = false;
            const newLimit = _pendingPgiInfo[inx].pendingNewLimit;
            _pendingPgiInfo[inx].pendingNewLimit = '';
            if (!_pendingPgiInfo[inx].limitations?.includes(newLimit!)) {
                _pendingPgiInfo[inx].limitations?.push(newLimit!);
            }
            if (newLimit) {
                setPgiLmitExtraOption([...pgiLmitExtraOption, { label: newLimit!, value: newLimit! }]);
            }
        }
        setPendingPgiInfo(_pendingPgiInfo);
    };

    const onPigIsAddingLimitChange = (inx: number, val: boolean) => {
        const _pendingPgiInfo = [...pendingPgiInfo];
        if (_pendingPgiInfo.length > inx) {
            _pendingPgiInfo[inx].isAddingLimit = val;
        }
        setPendingPgiInfo(_pendingPgiInfo);
    };

    React.useEffect(() => {
        if (serviceTypeTemplate?.mandatory === false && !editValue && !isAdd) {
            setIsDisabled(true);
            onDisabled?.(true);
        } else if (editValue) {
            setIsDisabled(!!editValue.disableFlag);
            onDisabled?.(!!editValue.disableFlag);
        }
    }, [serviceTypeTemplate?.mandatory, editValue]);

    let tips1 =
        'Suggested duration: 30 minutes (based on our research). Duration can vary from 10 to 120 minutes depending on your specific service needs.';
    const tips2 =
        'Your expected payment for services rendered to patients, reflecting the total amount to be deposited into your bank account';
    const tips3 = "Klarity's additional charge for marketing your services to patients";
    const tips4 = 'Costs associated with listing your services on various channels.';
    const tips5 = 'The complete cost a patient will pay for your service package.';
    const tips6 = "Ava's price recommendation for you, grounded in our comprehensive market research.";
    if (serviceType === EServiceType.CONSULTATION) {
        tips1 =
            'Suggested duration: 10 minutes (based on our research). Duration can vary from 5 to 10 minutes depending on your specific service needs.';
    }
    if (serviceType === EServiceType.ESTABLISHED_PATIENT_VISIT) {
        tips1 =
            'Suggested duration: 20 minutes (based on our research). Duration can vary from 10 to 120 minutes depending on your specific service needs.';
    }
    if (serviceType === EServiceType.PRESCRIPTION_SERVICE) {
        tips1 =
            'Suggested duration: 10 minutes (based on our research). Duration can vary from 5 to 30 minutes depending on your specific service needs.';
    }
    if (serviceType === EServiceType.OTHER_PATIENT_SUPPORT) {
        tips1 =
            'Suggested duration: 10 minutes (based on our research). Duration can vary from 5 to 60 minutes depending on your specific service needs.';
    }
    if (serviceType === EServiceType.MEDICATIONS) {
        tips1 = 'Free shipping will have a better patient experience, but you can edit the shipment fee.';
    }

    const targetNameTips: undefined | { reminder: string; toolTips: string } =
        SPECIALTY_TIPS_MAP[service?.specialtyName as ESpecialty];
    const hasNameTips = !!targetNameTips;

    const originalPgiAcceptOption: StrMeta[] = [...pgiAcceptOption];
    if (originalPgiAcceptOption.length > 0) {
        originalPgiAcceptOption.push({ label: 'All above', value: 'all' });
    }
    const numRows = Math.ceil(originalPgiAcceptOption.length / 2);

    const column1 = originalPgiAcceptOption.slice(0, numRows);
    const column2 = originalPgiAcceptOption.slice(numRows);

    const updatedPgiAcceptOption: StrMeta[] = [];
    let updatedPgiAcceptOptionInx = 0;
    while (updatedPgiAcceptOptionInx < column1.length) {
        if (column1[updatedPgiAcceptOptionInx]) {
            updatedPgiAcceptOption.push(column1[updatedPgiAcceptOptionInx]);
        }
        if (column2[updatedPgiAcceptOptionInx]) {
            updatedPgiAcceptOption.push(column2[updatedPgiAcceptOptionInx]);
        }
        updatedPgiAcceptOptionInx++;
    }

    const updateRecommandPriceArea = (state: string, val: number = 0) => {
        generatePrices(val, state);
    };

    const getTimePrice = (val: number) => {
        let timePrice = 0;
        if (val < 40) {
            timePrice = 0;
        } else if (val < 50) {
            timePrice = 20;
        } else if (val < 60) {
            timePrice = 40;
        } else if (val >= 60) {
            timePrice = 60;
        }

        return timePrice;
    };

    useEffect(() => {
        states.forEach((state) => {
            const timePrice = getTimePrice(stateContentDurationMap[state] || 0);
            updateRecommandPriceArea(state, timePrice);
        });
    }, [stateContentDurationMap, states, serviceType]);

    const [modalVisible, setModalVisible] = useState(false);

    const titleIndex: {
        priceNDuration: number;
        contactTypeIndex: number;
        patientGroupIndex: string;
        paymentsIndex: number;
        acceptedPaymentIndex: number;
        billingCodesIndex: number;
        insuranceCarriersIndex: number;
        patientIntakeIndex: number;
    } = useMemo(() => {
        let priceNDuration = 4;
        if (isKiwiUser) {
            priceNDuration = 5;
        }

        let acceptedPaymentIndex = 3;
        let billingCodesIndex = 4;
        let paymentsIndex = 4;
        let patientIntakeIndex = 7;

        if (showControlledMedicationRefills) {
            paymentsIndex = 5;
            acceptedPaymentIndex = 4;
            billingCodesIndex = 5;
            patientIntakeIndex = 6;
        }
        if (isMedications) {
            priceNDuration = 5;
            acceptedPaymentIndex = 4;
            billingCodesIndex = 5;
            paymentsIndex = 6;
        }
        if (isKiwiUser) {
            paymentsIndex = acceptedPaymentIndex + 1;
            billingCodesIndex = paymentsIndex + 1;
        }

        const insuranceCarriersIndex = isKiwiUser ? billingCodesIndex + 1 : paymentsIndex + 1;

        let contactTypeIndex = 4;
        if (isKiwiUser) {
            contactTypeIndex = billingCodesIndex + 1;
        }

        let patientGroupIndex = serviceTypeTemplate?.switchTeleHealthInPerson === false ? '4' : '5';
        if (isKiwiUser) {
            patientGroupIndex = String(contactTypeIndex + 1);
        }

        return {
            priceNDuration,
            contactTypeIndex,
            patientGroupIndex,
            paymentsIndex,
            acceptedPaymentIndex,
            billingCodesIndex,
            insuranceCarriersIndex,
            patientIntakeIndex,
        };
    }, [isKiwiUser, isMedications, pendingPaymentType, serviceTypeTemplate, showControlledMedicationRefills]);

    const getInsuranceOptionsByState = (state: string) => {
        const options = uniprofileInsuranceData?.filter((item) => item.state === state);
        console.log({
            uniprofileInsuranceData,
        });
        if (options) {
            setInsuranceCarrierOptions(options);
        }
    };

    const handleAddInsurance = async (state: string) => {
        console.log({
            state,
        });
        await getInsuranceOptionsByState(state);
        setModalVisible(true);
    };

    const handleSave = (carriers: string[], plans: Record<string, string[]>) => {
        console.log('Selected carriers:', carriers);
        console.log('Selected plans:', Object.values(plans).flat());
        if (currentEditInsuranceRowData && currentEditInsuranceRowData?.dictKey) {
            setStateContentInsuranceCarrierMap((prev) => ({
                ...prev,
                [currentEditInsuranceRowData.content as string]: carriers,
            }));
            setStateContentInsurancePlanMap((prev) => ({
                ...prev,
                [currentEditInsuranceRowData.content as string]: plans,
            }));
        }
        setModalVisible(false);
    };

    const klarityServicePriceDataColumns: ColumnsType<ServerMeta> = [
        {
            title: <div className={s.tableTitle}>STATES</div>,
            width: '120px',
            render: (state: ServerMeta) => {
                return <div className={s.colState}>{state.content}</div>;
            },
        },
        {
            title: (
                <div className={s.tableTitle}>
                    <span>DURATION(MINS)</span>
                    <span className={s.icon}>
                        <Popover content={<div className={s.toolWrap}>{tips1}</div>} trigger="hover">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="17"
                                viewBox="0 0 17 17"
                                fill="none"
                            >
                                <path
                                    d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                    stroke="#6B7280"
                                    strokeWidth="1.33594"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Popover>
                    </span>
                </div>
            ),
            key: 'duration',
            width: '150px',
            render: (item: ServerMeta) => {
                const defalutVal =
                    serviceTypeTemplateValue?.duration !== undefined && serviceTypeTemplateValue?.duration !== null
                        ? serviceTypeTemplateValue.duration
                        : serviceTypeTemplate?.defaultDuration || 30;
                // if (isLaFireSpe) {
                //     return <span>{defalutVal}</span>;
                // }
                if (disablePriceNDurationEdit) {
                    return <span>{stateContentDurationMap[item.content]}</span>;
                }
                return (
                    <div className={s.colDurWrap}>
                        <InputNumber
                            step={1}
                            value={stateContentDurationMap[item.content]}
                            onChange={(e) => {
                                const _stateContentDurationMap = {
                                    ...stateContentDurationMap,
                                };
                                _stateContentDurationMap[item.content] = e!;
                                setStateContentDurationMap(_stateContentDurationMap);
                                const timePrice = getTimePrice(e!);
                                updateRecommandPriceArea(item.content, timePrice);
                            }}
                            onBlur={(e) => {
                                if (!e.target.value) {
                                    const _stateContentDurationMap = {
                                        ...stateContentDurationMap,
                                    };
                                    _stateContentDurationMap[item.content] = defalutVal!;
                                    setStateContentDurationMap(_stateContentDurationMap);
                                } else {
                                    let val = parseInt(e.target.value, 10);
                                    const min = serviceTypeTemplate?.minDuration || 0;
                                    const max = serviceTypeTemplate?.maxDuration || 1000;
                                    if (val > max) {
                                        val = max;
                                    } else if (val < min) {
                                        val = min;
                                    }
                                    const _stateContentDurationMap = {
                                        ...stateContentDurationMap,
                                    };
                                    _stateContentDurationMap[item.content] = val!;
                                    setStateContentDurationMap(_stateContentDurationMap);
                                }
                            }}
                            size="small"
                            defaultValue={defalutVal}
                            max={serviceTypeTemplate?.maxDuration || 1000}
                            min={serviceTypeTemplate?.minDuration || 0}
                        />
                    </div>
                );
            },
        },
        {
            key: 'myEarnings',
            title: (
                <div className={s.tableTitle}>
                    <span>MY EARNINGS</span>
                    <span className={s.icon}>
                        <Popover content={<div className={s.toolWrap}>{tips2}</div>} trigger="hover">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="17"
                                viewBox="0 0 17 17"
                                fill="none"
                            >
                                <path
                                    d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                    stroke="#6B7280"
                                    strokeWidth="1.33594"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Popover>
                    </span>
                </div>
            ),
            width: '150px',
            render: (item: ServerMeta) => {
                // if (isLaFireSpe) {
                //     return <span>${LA_FIRE_SERVICE_PRICE}</span>;
                // }
                return disablePriceNDurationEdit ? (
                    <span>${stateContentMyEaringMap[item.content]}</span>
                ) : (
                    <EarningEditor
                        // stateContentDurationMap={stateContentDurationMap}
                        consultationOverPrice={consultationOverPrice}
                        isConsultation={isConsultation}
                        item={item}
                        serviceType={serviceType}
                        stateContentMyEaringMap={stateContentMyEaringMap}
                        setStateContentMyEaringMap={setStateContentMyEaringMap}
                        allStateConfigTypePriceData={allStateConfigTypePriceData}
                        // value={stateContentMyEaringMap[item.content]}
                        // onChange={(e) => {
                        //     const _stateContentMyEaringMap = { ...stateContentMyEaringMap };
                        //     _stateContentMyEaringMap[item.content] = e!;
                        //     setStateContentMyEaringMap(_stateContentMyEaringMap);
                        // }}
                    />
                );
            },
        },
        {
            key: 'marketingMarkup',
            title: (
                <div className={s.tableTitle}>
                    <span>MARKETING MARKUP</span>
                    <span className={s.icon}>
                        <Popover content={<div className={s.toolWrap}>{tips3}</div>} trigger="hover">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="17"
                                viewBox="0 0 17 17"
                                fill="none"
                            >
                                <path
                                    d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                    stroke="#6B7280"
                                    strokeWidth="1.33594"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Popover>
                    </span>
                </div>
            ),
            width: '120px',
            render: (item: ServerMeta) => {
                if (klarityTemplate === WEIGHT_LOSS_15_MINS_TEMPLATE) {
                    return `$${allStateConfigTypePriceData?.[item.content]?.[WEIGHT_LOSS_15_MINS_TEMPLATE]?.mmu || 0}`;
                }
                const statePrice = allStateConfigTypePriceData?.[item.content];

                let val = statePrice?.[EServiceType.INIT]?.mmu;
                if (serviceType === EServiceType.CONSULTATION) {
                    val = statePrice?.[EServiceType.CONSULTATION]?.mmu;
                }
                if (serviceType === EServiceType.ESTABLISHED_PATIENT_VISIT) {
                    val = statePrice?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.mmu;
                }
                if (serviceType === EServiceType.PRESCRIPTION_SERVICE) {
                    val = statePrice?.[EServiceType.PRESCRIPTION_SERVICE]?.mmu;
                }
                if (serviceType === EServiceType.MEDICATIONS) {
                    val = statePrice?.[EServiceType.MEDICATIONS]?.mmu;
                }
                if (serviceType === EServiceType.OTHER_PATIENT_SUPPORT) {
                    val = statePrice?.[EServiceType.OTHER_PATIENT_SUPPORT]?.mmu;
                }

                const display = `$${val || 0}`;
                if (
                    serviceType === EServiceType.CONSULTATION &&
                    (statePrice?.[EServiceType.INIT]?.mmu || 0) > (statePrice?.[EServiceType.CONSULTATION]?.mmu || 0)
                ) {
                    return (
                        <div className={s.colVal}>
                            <span className={s.v1}>${statePrice?.[EServiceType.INIT]?.mmu}</span>
                            <span className={s.move}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="8"
                                    viewBox="0 0 22 8"
                                    fill="none"
                                >
                                    <path
                                        d="M20.8848 4.35355C21.0801 4.15829 21.0801 3.84171 20.8848 3.64645L17.7028 0.464466C17.5076 0.269204 17.191 0.269204 16.9957 0.464466C16.8005 0.659728 16.8005 0.976311 16.9957 1.17157L19.8241 4L16.9957 6.82843C16.8005 7.02369 16.8005 7.34027 16.9957 7.53553C17.191 7.7308 17.5076 7.7308 17.7028 7.53553L20.8848 4.35355ZM0.03125 4.5H20.5312V3.5H0.03125V4.5Z"
                                        fill="#00816B"
                                    />
                                </svg>
                            </span>
                            <span className={s.v2}>${statePrice?.[EServiceType.CONSULTATION]?.mmu || 0}</span>
                        </div>
                    );
                }

                if (
                    serviceType === EServiceType.ESTABLISHED_PATIENT_VISIT &&
                    (statePrice?.[EServiceType.INIT]?.mmu || 0) >
                        (statePrice?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.mmu || 0)
                ) {
                    return (
                        <div className={s.colVal}>
                            <span className={s.v1}>${statePrice?.[EServiceType.INIT]?.mmu}</span>
                            <span className={s.move}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="8"
                                    viewBox="0 0 22 8"
                                    fill="none"
                                >
                                    <path
                                        d="M20.8848 4.35355C21.0801 4.15829 21.0801 3.84171 20.8848 3.64645L17.7028 0.464466C17.5076 0.269204 17.191 0.269204 16.9957 0.464466C16.8005 0.659728 16.8005 0.976311 16.9957 1.17157L19.8241 4L16.9957 6.82843C16.8005 7.02369 16.8005 7.34027 16.9957 7.53553C17.191 7.7308 17.5076 7.7308 17.7028 7.53553L20.8848 4.35355ZM0.03125 4.5H20.5312V3.5H0.03125V4.5Z"
                                        fill="#00816B"
                                    />
                                </svg>
                            </span>
                            <span className={s.v2}>
                                ${statePrice?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.mmu || 0}
                            </span>
                        </div>
                    );
                }

                if (
                    serviceType === EServiceType.PRESCRIPTION_SERVICE &&
                    (statePrice?.[EServiceType.INIT]?.mmu || 0) >
                        (statePrice?.[EServiceType.PRESCRIPTION_SERVICE]?.mmu || 0)
                ) {
                    return (
                        <div className={s.colVal}>
                            <span className={s.v1}>${statePrice?.[EServiceType.INIT]?.mmu}</span>
                            <span className={s.move}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="8"
                                    viewBox="0 0 22 8"
                                    fill="none"
                                >
                                    <path
                                        d="M20.8848 4.35355C21.0801 4.15829 21.0801 3.84171 20.8848 3.64645L17.7028 0.464466C17.5076 0.269204 17.191 0.269204 16.9957 0.464466C16.8005 0.659728 16.8005 0.976311 16.9957 1.17157L19.8241 4L16.9957 6.82843C16.8005 7.02369 16.8005 7.34027 16.9957 7.53553C17.191 7.7308 17.5076 7.7308 17.7028 7.53553L20.8848 4.35355ZM0.03125 4.5H20.5312V3.5H0.03125V4.5Z"
                                        fill="#00816B"
                                    />
                                </svg>
                            </span>
                            <span className={s.v2}>${statePrice?.[EServiceType.PRESCRIPTION_SERVICE]?.mmu || 0}</span>
                        </div>
                    );
                }

                if (
                    serviceType === EServiceType.OTHER_PATIENT_SUPPORT &&
                    (statePrice?.[EServiceType.INIT]?.mmu || 0) >
                        (statePrice?.[EServiceType.OTHER_PATIENT_SUPPORT]?.mmu || 0)
                ) {
                    return (
                        <div className={s.colVal}>
                            <span className={s.v1}>${statePrice?.[EServiceType.INIT]?.mmu}</span>
                            <span className={s.move}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="8"
                                    viewBox="0 0 22 8"
                                    fill="none"
                                >
                                    <path
                                        d="M20.8848 4.35355C21.0801 4.15829 21.0801 3.84171 20.8848 3.64645L17.7028 0.464466C17.5076 0.269204 17.191 0.269204 16.9957 0.464466C16.8005 0.659728 16.8005 0.976311 16.9957 1.17157L19.8241 4L16.9957 6.82843C16.8005 7.02369 16.8005 7.34027 16.9957 7.53553C17.191 7.7308 17.5076 7.7308 17.7028 7.53553L20.8848 4.35355ZM0.03125 4.5H20.5312V3.5H0.03125V4.5Z"
                                        fill="#00816B"
                                    />
                                </svg>
                            </span>
                            <span className={s.v2}>${statePrice?.[EServiceType.OTHER_PATIENT_SUPPORT]?.mmu || 0}</span>
                        </div>
                    );
                }
                return <div className={s.colVal}>{display}</div>;
            },
        },
        {
            key: 'platformFee',
            title: (
                <div className={s.tableTitle}>
                    <span>PLATFORM FEE</span>
                    <span className={s.icon}>
                        <Popover content={<div className={s.toolWrap}>{tips4}</div>} trigger="hover">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="17"
                                viewBox="0 0 17 17"
                                fill="none"
                            >
                                <path
                                    d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                    stroke="#6B7280"
                                    strokeWidth="1.33594"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Popover>
                    </span>
                </div>
            ),
            width: '120px',
            render: (item: ServerMeta) => {
                if (klarityTemplate === WEIGHT_LOSS_15_MINS_TEMPLATE) {
                    return `$${allStateConfigTypePriceData?.[item.content]?.[WEIGHT_LOSS_15_MINS_TEMPLATE]?.pf || 0}`;
                }
                const statePrice = allStateConfigTypePriceData?.[item.content];

                let val = statePrice?.[EServiceType.INIT]?.pf;
                if (serviceType === EServiceType.CONSULTATION) {
                    val = statePrice?.[EServiceType.CONSULTATION]?.pf;
                }
                if (serviceType === EServiceType.ESTABLISHED_PATIENT_VISIT) {
                    val = statePrice?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.pf;
                }
                if (serviceType === EServiceType.PRESCRIPTION_SERVICE) {
                    val = statePrice?.[EServiceType.PRESCRIPTION_SERVICE]?.pf;
                }
                if (serviceType === EServiceType.OTHER_PATIENT_SUPPORT) {
                    val = statePrice?.[EServiceType.OTHER_PATIENT_SUPPORT]?.pf;
                }
                const display = `$${val || 0}`;

                const earning = stateContentMyEaringMap[item.content];
                if (earning && isConsultation && earning > consultationOverPrice && val === 0) {
                    //use init PLATFORM FEE
                    return <div className={s.colVal}>{`$${statePrice?.[EServiceType.INIT]?.pf || 0}`}</div>;
                }

                if (
                    serviceType === EServiceType.CONSULTATION &&
                    (statePrice?.[EServiceType.INIT]?.pf || 0) > (statePrice?.[EServiceType.CONSULTATION]?.pf || 0)
                ) {
                    return (
                        <div className={s.colVal}>
                            <span className={s.v1}>${statePrice?.[EServiceType.INIT]?.pf}</span>
                            <span className={s.move}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="8"
                                    viewBox="0 0 22 8"
                                    fill="none"
                                >
                                    <path
                                        d="M20.8848 4.35355C21.0801 4.15829 21.0801 3.84171 20.8848 3.64645L17.7028 0.464466C17.5076 0.269204 17.191 0.269204 16.9957 0.464466C16.8005 0.659728 16.8005 0.976311 16.9957 1.17157L19.8241 4L16.9957 6.82843C16.8005 7.02369 16.8005 7.34027 16.9957 7.53553C17.191 7.7308 17.5076 7.7308 17.7028 7.53553L20.8848 4.35355ZM0.03125 4.5H20.5312V3.5H0.03125V4.5Z"
                                        fill="#00816B"
                                    />
                                </svg>
                            </span>
                            <span className={s.v2}>${statePrice?.[EServiceType.CONSULTATION]?.pf || 0}</span>
                        </div>
                    );
                }
                return <div className={s.colVal}>{display}</div>;
            },
        },
        {
            title: (
                <div className={s.tableTitle}>
                    <span>PATIENT COST</span>
                    <span className={s.icon}>
                        <Popover content={<div className={s.toolWrap}>{tips5}</div>} trigger="hover">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="17"
                                viewBox="0 0 17 17"
                                fill="none"
                            >
                                <path
                                    d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                    stroke="#6B7280"
                                    strokeWidth="1.33594"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Popover>
                    </span>
                </div>
            ),
            width: '200px',
            render: (item: ServerMeta) => {
                // if (isLaFireSpe) {
                //     return <span>${LA_FIRE_SERVICE_PRICE}</span>;
                // }
                if (klarityTemplate === WEIGHT_LOSS_15_MINS_TEMPLATE) {
                    return `$${allStateConfigTypePriceData?.[item.content]?.[WEIGHT_LOSS_15_MINS_TEMPLATE]?.krc || 0}`;
                }
                if (isKiwiUser && !disablePatientCostEdit) {
                    return (
                        <InputNumber
                            value={stateContentPatientCostMap[item.content]}
                            onChange={(e) => {
                                const _stateContentPatientCostMap: Record<string, number> = {};
                                _stateContentPatientCostMap[item.content] = !e || e < 0 ? 0 : e;
                                setStateContentPatientCostMap((prev) => ({
                                    ...prev,
                                    ..._stateContentPatientCostMap,
                                }));
                            }}
                        />
                    );
                }
                const statePrice = allStateConfigTypePriceData?.[item.content];

                let defaultVal = statePrice?.[EServiceType.INIT]?.krc;
                let mmuPrice = statePrice?.[EServiceType.INIT]?.mmu;
                let pfPrice = statePrice?.[EServiceType.INIT]?.pf;
                if (serviceType === EServiceType.CONSULTATION) {
                    defaultVal = statePrice?.[EServiceType.CONSULTATION]?.krc;
                    mmuPrice = statePrice?.[EServiceType.CONSULTATION]?.mmu;
                    pfPrice = statePrice?.[EServiceType.CONSULTATION]?.pf;

                    const earning = stateContentMyEaringMap[item.content];
                    if (earning && isConsultation && earning > consultationOverPrice && pfPrice === 0) {
                        pfPrice = statePrice?.[EServiceType.INIT]?.pf;
                    }
                }
                if (serviceType === EServiceType.ESTABLISHED_PATIENT_VISIT) {
                    defaultVal = statePrice?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.krc;
                    mmuPrice = statePrice?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.mmu;
                    pfPrice = statePrice?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.pf;
                }
                if (serviceType === EServiceType.PRESCRIPTION_SERVICE) {
                    defaultVal = statePrice?.[EServiceType.PRESCRIPTION_SERVICE]?.krc;
                    mmuPrice = statePrice?.[EServiceType.PRESCRIPTION_SERVICE]?.mmu;
                    pfPrice = statePrice?.[EServiceType.PRESCRIPTION_SERVICE]?.pf;
                }
                if (serviceType === EServiceType.OTHER_PATIENT_SUPPORT) {
                    defaultVal = statePrice?.[EServiceType.OTHER_PATIENT_SUPPORT]?.krc;
                    mmuPrice = statePrice?.[EServiceType.OTHER_PATIENT_SUPPORT]?.mmu;
                    pfPrice = statePrice?.[EServiceType.OTHER_PATIENT_SUPPORT]?.pf;
                }

                const total =
                    statePrice &&
                    stateContentMyEaringMap[item.content] !== undefined &&
                    stateContentMyEaringMap[item.content] !== null
                        ? stateContentMyEaringMap[item.content] + mmuPrice! + pfPrice!
                        : 0;

                return <div className={s.colVal}>${total}</div>;
            },
        },
        {
            title: (
                <div className={s.tableTitle}>
                    <span>PROVIDER SUPERBILL SUPPORT</span>
                    <span className={s.icon}>
                        <Popover
                            content={
                                <div className={s.toolWrap}>
                                    Provides assistance with coding, documentation, and submission of superbills to
                                    maximize reimbursement and reduce claim denials for patients.
                                </div>
                            }
                            trigger="hover"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="17"
                                viewBox="0 0 17 17"
                                fill="none"
                            >
                                <path
                                    d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                    stroke="#6B7280"
                                    strokeWidth="1.33594"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Popover>
                    </span>
                </div>
            ),
            key: 'superBillSupport',
            render: (val: any, item: ServerMeta) => {
                return (
                    <Switch
                        checked={!!stateContentSuperBillSupportMap[item.content!]}
                        onChange={(e) => {
                            const _stateContentSuperBillSupportMap = {
                                ...stateContentSuperBillSupportMap,
                            };
                            _stateContentSuperBillSupportMap[item.content!] = e;
                            setStateContentSuperBillSupportMap(_stateContentSuperBillSupportMap);
                        }}
                    />
                );
            },
        },
        {
            title: (
                <div className={s.tableTitle}>
                    <span>AVA PRICE INSIGHTS</span>
                    <span className={s.icon}>
                        <Popover content={<div className={s.toolWrap}>{tips6}</div>} trigger="hover">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="17"
                                viewBox="0 0 17 17"
                                fill="none"
                            >
                                <path
                                    d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                    stroke="#6B7280"
                                    strokeWidth="1.33594"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Popover>
                    </span>
                </div>
            ),
            key: 'avaPriceInsights',
            render: (val, item: ServerMeta) => {
                if (isLaFireSpe) {
                    return <span>Average</span>;
                }
                // const statePrice = allStateConfigTypePriceData?.[item.content];

                const timePrice = getTimePrice(stateContentDurationMap[item.content] || 0);
                const recommendPriceAreaData = handleGetPricesNRange(timePrice, item.content);
                let defaultVal = recommendPriceAreaData?.[item.content]?.[EServiceType.INIT]?.krc;
                let mmuPrice = recommendPriceAreaData?.[item.content]?.[EServiceType.INIT]?.mmu;
                let pfPrice = recommendPriceAreaData?.[item.content]?.[EServiceType.INIT]?.pf;
                let recommendPriceArea =
                    recommendPriceAreaData?.[item.content]?.[EServiceType.INIT]?.recommendPriceArea;
                if (serviceType === EServiceType.CONSULTATION) {
                    defaultVal = recommendPriceAreaData?.[item.content]?.[EServiceType.CONSULTATION]?.krc;
                    mmuPrice = recommendPriceAreaData?.[item.content]?.[EServiceType.CONSULTATION]?.mmu;
                    pfPrice = recommendPriceAreaData?.[item.content]?.[EServiceType.CONSULTATION]?.pf;
                    recommendPriceArea =
                        recommendPriceAreaData?.[item.content]?.[EServiceType.CONSULTATION]?.recommendPriceArea;

                    const earning = stateContentMyEaringMap[item.content];
                    if (earning && isConsultation && earning > consultationOverPrice && pfPrice === 0) {
                        pfPrice = recommendPriceAreaData?.[item.content]?.[EServiceType.INIT]?.pf;
                        recommendPriceArea =
                            recommendPriceAreaData?.[item.content]?.[EServiceType.CONSULTATION_OVERCHARGE]
                                ?.recommendPriceArea;
                    }
                }
                if (serviceType === EServiceType.ESTABLISHED_PATIENT_VISIT) {
                    defaultVal = recommendPriceAreaData?.[item.content]?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.krc;
                    mmuPrice = recommendPriceAreaData?.[item.content]?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.mmu;
                    pfPrice = recommendPriceAreaData?.[item.content]?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.pf;
                    recommendPriceArea =
                        recommendPriceAreaData?.[item.content]?.[EServiceType.ESTABLISHED_PATIENT_VISIT]
                            ?.recommendPriceArea;
                }
                if (serviceType === EServiceType.PRESCRIPTION_SERVICE) {
                    defaultVal = recommendPriceAreaData?.[item.content]?.[EServiceType.PRESCRIPTION_SERVICE]?.krc;
                    mmuPrice = recommendPriceAreaData?.[item.content]?.[EServiceType.PRESCRIPTION_SERVICE]?.mmu;
                    pfPrice = recommendPriceAreaData?.[item.content]?.[EServiceType.PRESCRIPTION_SERVICE]?.pf;
                    recommendPriceArea =
                        recommendPriceAreaData?.[item.content]?.[EServiceType.PRESCRIPTION_SERVICE]?.recommendPriceArea;
                }
                if (serviceType === EServiceType.OTHER_PATIENT_SUPPORT) {
                    defaultVal = recommendPriceAreaData?.[item.content]?.[EServiceType.OTHER_PATIENT_SUPPORT]?.krc;
                    mmuPrice = recommendPriceAreaData?.[item.content]?.[EServiceType.OTHER_PATIENT_SUPPORT]?.mmu;
                    pfPrice = recommendPriceAreaData?.[item.content]?.[EServiceType.OTHER_PATIENT_SUPPORT]?.pf;
                    recommendPriceArea =
                        recommendPriceAreaData?.[item.content]?.[EServiceType.OTHER_PATIENT_SUPPORT]
                            ?.recommendPriceArea;
                }
                const shippingFee = stateContentShippingFeeMap[item.content];

                const total =
                    stateContentMyEaringMap[item.content] !== undefined &&
                    stateContentMyEaringMap[item.content] !== null
                        ? stateContentMyEaringMap[item.content] + mmuPrice! + pfPrice! + shippingFee!
                        : undefined;

                const [level, percent] = getKlarityPriceLevel(total, recommendPriceArea);
                const tipsClass = s.tips;
                let tipText = '';

                if (level === 1) {
                    // tipsClass = `${s.tips} ${s.tipsLevel1}`;
                    // tipText = `$${total} is very competitive in your area`;
                    tipText = 'Very competitive';
                }
                if (level === 2) {
                    // tipsClass = `${s.tips} ${s.tipsLevel2}`;
                    // tipText = `$${total} is competitive in your area`;
                    tipText = 'Competitive';
                }
                if (level === 3) {
                    // tipsClass = `${s.tips} ${s.tipsLevel3}`;
                    // tipText = `$${total} is average in your area`;
                    tipText = 'Average';
                }
                if (level === 4) {
                    // tipsClass = `${s.tips} ${s.tipsLevel4}`;
                    // tipText = `$${total} is high in your area`;
                    tipText = 'High';
                }
                if (level === 5) {
                    // tipsClass = `${s.tips} ${s.tipsLevel5}`;
                    // tipText = `$${total} is absolutely not competitive`;
                    tipText = 'Not competitive';
                }
                return (
                    <div className={s.barWrap}>
                        {/* <div className={s.bar}>
                            <div className={s.bar1} />
                            <div className={s.bar2} />
                            <div className={s.bar3} />
                            <div className={s.bar4} />
                            <div className={s.bar5} />
                        </div>
                        <div className={s.icon} style={{ left: `${percent}%` }}>
                            {
                                level === 1 && <img src={Icon1} />
                            }
                            {
                                level === 2 && <img src={Icon2} />
                            }
                            {
                                level === 3 && <img src={Icon3} />
                            }
                            {
                                level === 4 && <img src={Icon4} />
                            }
                            {
                                level === 5 && <img src={Icon5} />
                            }
                        </div> */}
                        {/* <div className={tipsClass}>
                            {tipText}
                        </div> */}
                        {tipText}
                    </div>
                );
            },
        },
    ]
        .filter((item) => {
            if (isKiwiUser) {
                return (
                    item.key !== 'myEarnings' &&
                    item.key !== 'marketingMarkup' &&
                    item.key !== 'platformFee' &&
                    item.key !== 'avaPriceInsights'
                );
            }

            return item.key !== 'superBillSupport';
        })
        .filter((item) => {
            if (isKiwiUser && onlyInsurance) {
                return item.key !== 'duration';
            }
            return true;
        })
        .filter((item) => {
            if (isPrescriptionService) {
                return item.key !== 'duration';
            }
            return true;
        });

    const klarityServicePriceDataMedicationColumns: () => ColumnsType<ServerMeta> = () => {
        const columns = [
            {
                title: <div className={s.tableTitle}>STATES</div>,
                width: '120px',
                render: (state: ServerMeta) => {
                    return <div className={s.colState}>{state.content}</div>;
                },
            },
            {
                title: (
                    <div className={s.tableTitle}>
                        <span>MY EARNINGS</span>
                        <span className={s.icon}>
                            <Popover content={<div className={s.toolWrap}>{tips2}</div>} trigger="hover">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                >
                                    <path
                                        d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                        stroke="#6B7280"
                                        strokeWidth="1.33594"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </Popover>
                        </span>
                    </div>
                ),
                key: 'myEarnings',
                width: '150px',
                render: (item: ServerMeta) => {
                    if (isMedications) {
                        const defaultVal = 0;
                        return (
                            <div className={s.colDurWrap}>
                                <InputNumber
                                    step={1}
                                    value={stateContentMyEaringMap[item.content]}
                                    onChange={(e) => {
                                        const _stateContentMyEaringMap = {
                                            ...stateContentMyEaringMap,
                                        };
                                        _stateContentMyEaringMap[item.content] = e!;
                                        setStateContentMyEaringMap(_stateContentMyEaringMap);
                                    }}
                                    onBlur={(e) => {
                                        if (!e.target.value) {
                                            const _stateContentMyEaringMap = {
                                                ...stateContentMyEaringMap,
                                            };
                                            stateContentMyEaringMap[item.content] = defaultVal!;
                                            setStateContentMyEaringMap(_stateContentMyEaringMap);
                                        } else {
                                            const val = parseInt(e.target.value, 10);
                                            // const min = serviceTypeTemplate?.minDuration || 0;
                                            // const max = serviceTypeTemplate?.maxDuration || 1000;
                                            // if (val > max) {
                                            //     val = max;
                                            // } else if (val < min) {
                                            //     val = min;
                                            // }
                                            const _stateContentMyEaringMap = {
                                                ...stateContentMyEaringMap,
                                            };
                                            _stateContentMyEaringMap[item.content] = val!;
                                            setStateContentMyEaringMap(_stateContentMyEaringMap);
                                        }
                                    }}
                                    size="small"
                                    defaultValue={defaultVal}
                                    // max={serviceTypeTemplate?.maxDuration || 1000}
                                    // min={serviceTypeTemplate?.minDuration || 0}
                                />
                            </div>
                        );
                    }
                    return (
                        <EarningEditor
                            // stateContentDurationMap={stateContentDurationMap}
                            consultationOverPrice={consultationOverPrice}
                            isConsultation={isConsultation}
                            item={item}
                            serviceType={serviceType}
                            stateContentMyEaringMap={stateContentMyEaringMap}
                            setStateContentMyEaringMap={setStateContentMyEaringMap}
                            allStateConfigTypePriceData={allStateConfigTypePriceData}
                        />
                    );
                },
            },
            {
                title: (
                    <div className={s.tableTitle}>
                        <span>SHIPMENT FEE</span>
                        <span className={s.icon}>
                            <Popover content={<div className={s.toolWrap}>{tips1}</div>} trigger="hover">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                >
                                    <path
                                        d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                        stroke="#6B7280"
                                        strokeWidth="1.33594"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </Popover>
                        </span>
                    </div>
                ),
                width: '150px',
                render: (item: ServerMeta) => {
                    //const defalutVal = (serviceTypeTemplateValue?.duration !== undefined && serviceTypeTemplateValue?.duration !== null) ? serviceTypeTemplateValue.duration : (serviceTypeTemplate?.defaultDuration || 30);
                    const defaultVal = 0;
                    return (
                        <div className={s.colDurWrap}>
                            <InputNumber
                                step={1}
                                value={stateContentShippingFeeMap[item.content]}
                                onChange={(e) => {
                                    const _stateContentShippingFeeMap = {
                                        ...stateContentShippingFeeMap,
                                    };
                                    _stateContentShippingFeeMap[item.content] = !e || e < 0 ? 0 : e;
                                    setStateContentShippingFeeMap(_stateContentShippingFeeMap);
                                }}
                                onBlur={(e) => {
                                    if (!e.target.value) {
                                        const _stateContentShippingFeeMap = {
                                            ...stateContentShippingFeeMap,
                                        };
                                        _stateContentShippingFeeMap[item.content] = defaultVal!;
                                        setStateContentShippingFeeMap(_stateContentShippingFeeMap);
                                    } else {
                                        const val = parseInt(e.target.value, 10);
                                        // const min = serviceTypeTemplate?.minDuration || 0;
                                        // const max = serviceTypeTemplate?.maxDuration || 1000;
                                        // if (val > max) {
                                        //     val = max;
                                        // } else if (val < min) {
                                        //     val = min;
                                        // }
                                        const _stateContentShippingFeeMap = {
                                            ...stateContentShippingFeeMap,
                                        };
                                        _stateContentShippingFeeMap[item.content] = val!;
                                        setStateContentShippingFeeMap(_stateContentShippingFeeMap);
                                    }
                                }}
                                size="small"
                                defaultValue={defaultVal}
                                // max={serviceTypeTemplate?.maxDuration || 1000}
                                // min={serviceTypeTemplate?.minDuration || 0}
                            />
                        </div>
                    );
                },
            },
            {
                title: (
                    <div className={s.tableTitle}>
                        <span>MARKETING MARKUP</span>
                        <span className={s.icon}>
                            <Popover content={<div className={s.toolWrap}>{tips3}</div>} trigger="hover">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                >
                                    <path
                                        d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                        stroke="#6B7280"
                                        strokeWidth="1.33594"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </Popover>
                        </span>
                    </div>
                ),
                key: 'marketingMarkup',
                width: '120px',
                render: (item: ServerMeta) => {
                    const statePrice = allStateConfigTypePriceData?.[item.content];

                    let val = statePrice?.[EServiceType.INIT]?.mmu;
                    if (serviceType === EServiceType.CONSULTATION) {
                        val = statePrice?.[EServiceType.CONSULTATION]?.mmu;
                    }
                    if (serviceType === EServiceType.ESTABLISHED_PATIENT_VISIT) {
                        val = statePrice?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.mmu;
                    }
                    if (serviceType === EServiceType.PRESCRIPTION_SERVICE) {
                        val = statePrice?.[EServiceType.PRESCRIPTION_SERVICE]?.mmu;
                    }
                    if (serviceType === EServiceType.MEDICATIONS) {
                        val = statePrice?.[EServiceType.MEDICATIONS]?.mmu;
                    }
                    if (serviceType === EServiceType.OTHER_PATIENT_SUPPORT) {
                        val = statePrice?.[EServiceType.OTHER_PATIENT_SUPPORT]?.mmu;
                    }

                    const display = `$${val || 0}`;
                    if (
                        serviceType === EServiceType.CONSULTATION &&
                        (statePrice?.[EServiceType.INIT]?.mmu || 0) >
                            (statePrice?.[EServiceType.CONSULTATION]?.mmu || 0)
                    ) {
                        return (
                            <div className={s.colVal}>
                                <span className={s.v1}>${statePrice?.[EServiceType.INIT]?.mmu}</span>
                                <span className={s.move}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="8"
                                        viewBox="0 0 22 8"
                                        fill="none"
                                    >
                                        <path
                                            d="M20.8848 4.35355C21.0801 4.15829 21.0801 3.84171 20.8848 3.64645L17.7028 0.464466C17.5076 0.269204 17.191 0.269204 16.9957 0.464466C16.8005 0.659728 16.8005 0.976311 16.9957 1.17157L19.8241 4L16.9957 6.82843C16.8005 7.02369 16.8005 7.34027 16.9957 7.53553C17.191 7.7308 17.5076 7.7308 17.7028 7.53553L20.8848 4.35355ZM0.03125 4.5H20.5312V3.5H0.03125V4.5Z"
                                            fill="#00816B"
                                        />
                                    </svg>
                                </span>
                                <span className={s.v2}>${statePrice?.[EServiceType.CONSULTATION]?.mmu || 0}</span>
                            </div>
                        );
                    }

                    if (
                        serviceType === EServiceType.ESTABLISHED_PATIENT_VISIT &&
                        (statePrice?.[EServiceType.INIT]?.mmu || 0) >
                            (statePrice?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.mmu || 0)
                    ) {
                        return (
                            <div className={s.colVal}>
                                <span className={s.v1}>${statePrice?.[EServiceType.INIT]?.mmu}</span>
                                <span className={s.move}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="8"
                                        viewBox="0 0 22 8"
                                        fill="none"
                                    >
                                        <path
                                            d="M20.8848 4.35355C21.0801 4.15829 21.0801 3.84171 20.8848 3.64645L17.7028 0.464466C17.5076 0.269204 17.191 0.269204 16.9957 0.464466C16.8005 0.659728 16.8005 0.976311 16.9957 1.17157L19.8241 4L16.9957 6.82843C16.8005 7.02369 16.8005 7.34027 16.9957 7.53553C17.191 7.7308 17.5076 7.7308 17.7028 7.53553L20.8848 4.35355ZM0.03125 4.5H20.5312V3.5H0.03125V4.5Z"
                                            fill="#00816B"
                                        />
                                    </svg>
                                </span>
                                <span className={s.v2}>
                                    ${statePrice?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.mmu || 0}
                                </span>
                            </div>
                        );
                    }

                    if (
                        serviceType === EServiceType.PRESCRIPTION_SERVICE &&
                        (statePrice?.[EServiceType.INIT]?.mmu || 0) >
                            (statePrice?.[EServiceType.PRESCRIPTION_SERVICE]?.mmu || 0)
                    ) {
                        return (
                            <div className={s.colVal}>
                                <span className={s.v1}>${statePrice?.[EServiceType.INIT]?.mmu}</span>
                                <span className={s.move}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="8"
                                        viewBox="0 0 22 8"
                                        fill="none"
                                    >
                                        <path
                                            d="M20.8848 4.35355C21.0801 4.15829 21.0801 3.84171 20.8848 3.64645L17.7028 0.464466C17.5076 0.269204 17.191 0.269204 16.9957 0.464466C16.8005 0.659728 16.8005 0.976311 16.9957 1.17157L19.8241 4L16.9957 6.82843C16.8005 7.02369 16.8005 7.34027 16.9957 7.53553C17.191 7.7308 17.5076 7.7308 17.7028 7.53553L20.8848 4.35355ZM0.03125 4.5H20.5312V3.5H0.03125V4.5Z"
                                            fill="#00816B"
                                        />
                                    </svg>
                                </span>
                                <span className={s.v2}>
                                    ${statePrice?.[EServiceType.PRESCRIPTION_SERVICE]?.mmu || 0}
                                </span>
                            </div>
                        );
                    }

                    if (
                        serviceType === EServiceType.OTHER_PATIENT_SUPPORT &&
                        (statePrice?.[EServiceType.INIT]?.mmu || 0) >
                            (statePrice?.[EServiceType.OTHER_PATIENT_SUPPORT]?.mmu || 0)
                    ) {
                        return (
                            <div className={s.colVal}>
                                <span className={s.v1}>${statePrice?.[EServiceType.INIT]?.mmu}</span>
                                <span className={s.move}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="8"
                                        viewBox="0 0 22 8"
                                        fill="none"
                                    >
                                        <path
                                            d="M20.8848 4.35355C21.0801 4.15829 21.0801 3.84171 20.8848 3.64645L17.7028 0.464466C17.5076 0.269204 17.191 0.269204 16.9957 0.464466C16.8005 0.659728 16.8005 0.976311 16.9957 1.17157L19.8241 4L16.9957 6.82843C16.8005 7.02369 16.8005 7.34027 16.9957 7.53553C17.191 7.7308 17.5076 7.7308 17.7028 7.53553L20.8848 4.35355ZM0.03125 4.5H20.5312V3.5H0.03125V4.5Z"
                                            fill="#00816B"
                                        />
                                    </svg>
                                </span>
                                <span className={s.v2}>
                                    ${statePrice?.[EServiceType.OTHER_PATIENT_SUPPORT]?.mmu || 0}
                                </span>
                            </div>
                        );
                    }
                    return <div className={s.colVal}>{display}</div>;
                },
            },
            {
                title: (
                    <div className={s.tableTitle}>
                        <span>PLATFORM FEE</span>
                        <span className={s.icon}>
                            <Popover content={<div className={s.toolWrap}>{tips4}</div>} trigger="hover">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                >
                                    <path
                                        d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                        stroke="#6B7280"
                                        strokeWidth="1.33594"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </Popover>
                        </span>
                    </div>
                ),
                key: 'platFormFee',
                width: '120px',
                render: (item: ServerMeta) => {
                    const statePrice = allStateConfigTypePriceData?.[item.content];

                    let val = statePrice?.[EServiceType.INIT]?.pf;
                    if (serviceType === EServiceType.CONSULTATION) {
                        val = statePrice?.[EServiceType.CONSULTATION]?.pf;
                    }
                    if (serviceType === EServiceType.ESTABLISHED_PATIENT_VISIT) {
                        val = statePrice?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.pf;
                    }
                    if (serviceType === EServiceType.PRESCRIPTION_SERVICE) {
                        val = statePrice?.[EServiceType.PRESCRIPTION_SERVICE]?.pf;
                    }
                    if (serviceType === EServiceType.MEDICATIONS) {
                        val = statePrice?.[EServiceType.MEDICATIONS]?.pf;
                    }
                    if (serviceType === EServiceType.OTHER_PATIENT_SUPPORT) {
                        val = statePrice?.[EServiceType.OTHER_PATIENT_SUPPORT]?.pf;
                    }
                    const display = `$${val || 0}`;

                    const earning = stateContentMyEaringMap[item.content];
                    if (earning && isConsultation && earning > consultationOverPrice && val === 0) {
                        //use init PLATFORM FEE
                        return <div className={s.colVal}>{`$${statePrice?.[EServiceType.INIT]?.pf || 0}`}</div>;
                    }

                    if (
                        serviceType === EServiceType.CONSULTATION &&
                        (statePrice?.[EServiceType.INIT]?.pf || 0) > (statePrice?.[EServiceType.CONSULTATION]?.pf || 0)
                    ) {
                        return (
                            <div className={s.colVal}>
                                <span className={s.v1}>${statePrice?.[EServiceType.INIT]?.pf}</span>
                                <span className={s.move}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="8"
                                        viewBox="0 0 22 8"
                                        fill="none"
                                    >
                                        <path
                                            d="M20.8848 4.35355C21.0801 4.15829 21.0801 3.84171 20.8848 3.64645L17.7028 0.464466C17.5076 0.269204 17.191 0.269204 16.9957 0.464466C16.8005 0.659728 16.8005 0.976311 16.9957 1.17157L19.8241 4L16.9957 6.82843C16.8005 7.02369 16.8005 7.34027 16.9957 7.53553C17.191 7.7308 17.5076 7.7308 17.7028 7.53553L20.8848 4.35355ZM0.03125 4.5H20.5312V3.5H0.03125V4.5Z"
                                            fill="#00816B"
                                        />
                                    </svg>
                                </span>
                                <span className={s.v2}>${statePrice?.[EServiceType.CONSULTATION]?.pf || 0}</span>
                            </div>
                        );
                    }
                    return <div className={s.colVal}>{display}</div>;
                },
            },
            {
                title: (
                    <div className={s.tableTitle}>
                        <span>PATIENT COST</span>
                        <span className={s.icon}>
                            <Popover content={<div className={s.toolWrap}>{tips5}</div>} trigger="hover">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                >
                                    <path
                                        d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                        stroke="#6B7280"
                                        strokeWidth="1.33594"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </Popover>
                        </span>
                    </div>
                ),
                width: '120px',
                render: (item: ServerMeta) => {
                    if (isKiwiUser) {
                        return (
                            <InputNumber
                                value={stateContentPatientCostMap[item.content]}
                                onChange={(e) => {
                                    const _stateContentPatientCostMap: Record<string, number> = {};
                                    _stateContentPatientCostMap[item.content] = !e || e < 0 ? 0 : e;
                                    setStateContentPatientCostMap((prev) => ({
                                        ...prev,
                                        ..._stateContentPatientCostMap,
                                    }));
                                }}
                            />
                        );
                    }
                    const statePrice = allStateConfigTypePriceData?.[item.content];

                    let defaultVal = statePrice?.[EServiceType.INIT]?.krc;
                    let mmuPrice = statePrice?.[EServiceType.INIT]?.mmu;
                    let pfPrice = statePrice?.[EServiceType.INIT]?.pf;

                    const shippingFee = stateContentShippingFeeMap[item.content] || 0;

                    if (serviceType === EServiceType.CONSULTATION) {
                        defaultVal = statePrice?.[EServiceType.CONSULTATION]?.krc;
                        mmuPrice = statePrice?.[EServiceType.CONSULTATION]?.mmu;
                        pfPrice = statePrice?.[EServiceType.CONSULTATION]?.pf;

                        const earning = stateContentMyEaringMap[item.content];
                        if (earning && isConsultation && earning > consultationOverPrice && pfPrice === 0) {
                            pfPrice = statePrice?.[EServiceType.INIT]?.pf;
                        }
                    }
                    if (serviceType === EServiceType.ESTABLISHED_PATIENT_VISIT) {
                        defaultVal = statePrice?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.krc;
                        mmuPrice = statePrice?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.mmu;
                        pfPrice = statePrice?.[EServiceType.ESTABLISHED_PATIENT_VISIT]?.pf;
                    }
                    if (serviceType === EServiceType.PRESCRIPTION_SERVICE) {
                        defaultVal = statePrice?.[EServiceType.PRESCRIPTION_SERVICE]?.krc;
                        mmuPrice = statePrice?.[EServiceType.PRESCRIPTION_SERVICE]?.mmu;
                        pfPrice = statePrice?.[EServiceType.PRESCRIPTION_SERVICE]?.pf;
                    }
                    if (serviceType === EServiceType.OTHER_PATIENT_SUPPORT) {
                        defaultVal = statePrice?.[EServiceType.OTHER_PATIENT_SUPPORT]?.krc;
                        mmuPrice = statePrice?.[EServiceType.OTHER_PATIENT_SUPPORT]?.mmu;
                        pfPrice = statePrice?.[EServiceType.OTHER_PATIENT_SUPPORT]?.pf;
                    }
                    if (serviceType === EServiceType.MEDICATIONS) {
                        defaultVal = statePrice?.[EServiceType.MEDICATIONS]?.krc;
                        mmuPrice = statePrice?.[EServiceType.MEDICATIONS]?.mmu;
                        pfPrice = statePrice?.[EServiceType.MEDICATIONS]?.pf;
                    }

                    let total =
                        statePrice &&
                        stateContentMyEaringMap[item.content] !== undefined &&
                        stateContentMyEaringMap[item.content] !== null
                            ? stateContentMyEaringMap[item.content] + mmuPrice! + pfPrice!
                            : 0;
                    if (isMedications) {
                        total += shippingFee;
                    }

                    return <div className={s.colVal}>${total}</div>;
                },
            },
        ];

        return isKiwiUser
            ? columns.filter(
                  (item) => item.key !== 'myEarnings' && item.key !== 'marketingMarkup' && item.key !== 'platFormFee',
              )
            : columns;
    };

    const contactDataColumns: ColumnsType<ServerMeta> = [
        {
            title: <div className={s.tableTitle}>STATES</div>,
            dataIndex: 'dictKey',
            key: 'dictKey',
            width: '120px',
            render: (state: string) => {
                return <div className={s.colState}>{state}</div>;
            },
        },
        {
            title: <div className={s.tableTitle}>TELE-HEALTH</div>,
            width: '150px',
            render: (val, item: ServerMeta) => {
                if (isLaFireSpe) {
                    return <Switch checked disabled />;
                }

                const contactSupport = stateContactTypeMap[item.content] || [];
                const check = contactSupport.includes(EContactType.TELE_HEALTH);
                if (disableContactTypeEdit) {
                    return <Switch checked={check} disabled />;
                }
                return (
                    <div className={s.colDurWrap}>
                        <Switch
                            checked={check}
                            onChange={(e) => {
                                onTeleChange(item, e);
                            }}
                        />
                    </div>
                );
            },
        },
        ...(useInsuranceComponent && !isPPV
            ? [
                  {
                      title: (
                          <div className={s.tableTitle}>
                              <span>PLACE OF SERVICE CODE</span>
                              <Tooltip title="The code that tells payers where the visit happened. It's set automatically from your contact type: 10 for telehealth, 11 for in person. Telehealth claims also include modifier 95.">
                                  <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="17"
                                      height="17"
                                      viewBox="0 0 17 17"
                                      fill="none"
                                  >
                                      <path
                                          d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                          stroke="#6B7280"
                                          strokeWidth="1.33594"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                      />
                                  </svg>
                              </Tooltip>
                          </div>
                      ),
                      width: '200px',
                      render: (val: any, item: ServerMeta) => {
                          return (
                              <Select
                                  showSearch
                                  value={stateTelehealthPosMap[item.content]}
                                  placeholder="Search a code"
                                  className={s.posSelect}
                                  filterOption={(input, option) =>
                                      (option?.label as string)?.toLowerCase().includes(input.toLowerCase())
                                  }
                                  onChange={(value) => onTelehealthPosChange(item, value)}
                                  options={placeOfServiceCodeOptions.map((opt) => ({
                                      label: `${opt.code} — ${opt.name}`,
                                      value: opt.code,
                                  }))}
                              />
                          );
                      },
                  },
                  {
                      title: (
                          <div className={s.tableTitle}>
                              <span>MODIFIER</span>
                              <Tooltip title="The code that tells payers where the visit happened. It's set automatically from your contact type: 10 for telehealth, 11 for in person. Telehealth claims also include modifier 95.">
                                  <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="17"
                                      height="17"
                                      viewBox="0 0 17 17"
                                      fill="none"
                                  >
                                      <path
                                          d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                          stroke="#6B7280"
                                          strokeWidth="1.33594"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                      />
                                  </svg>
                              </Tooltip>
                          </div>
                      ),
                      width: '200px',
                      render: (val: any, item: ServerMeta) => {
                          const selectedModifier = stateTelehealthModifierMap[item.content];
                          return (
                              <Select
                                  showSearch
                                  value={selectedModifier}
                                  placeholder="Search a code"
                                  className={s.posSelect}
                                  filterOption={(input, option) =>
                                      (option?.label as string)?.toLowerCase().includes(input.toLowerCase())
                                  }
                                  onChange={(value) => onTelehealthModifierChange(item, value)}
                                  options={modifierOptions.map((opt) => ({
                                      label: `${opt.code} — ${opt.name}`,
                                      value: opt.code,
                                  }))}
                              />
                          );
                      },
                  },
              ]
            : []),
        {
            title: <div className={s.tableTitle}>IN PERSON</div>,
            width: '150px',
            render: (val, item: ServerMeta) => {
                if (isLaFireSpe) {
                    return <Switch checked={false} disabled />;
                }
                const contactSupport = stateContactTypeMap[item.content] || [];
                const check = contactSupport.includes(EContactType.IN_PERSON);

                const allowAddressOptions = addressOptions?.filter((add: PracitceAddressForm) => {
                    return (
                        (add.practiceState?.toLowerCase() === item.dictKey.toLowerCase() ||
                            add.practiceState?.toLowerCase() === item.content.toLowerCase()) &&
                        [AddressPublicType.INVITATION, AddressPublicType.WALK_IN].includes(add.publicType)
                    );
                });

                const showTips = allowAddressOptions?.length === 0;
                const isRemoveAddressButChecked = isEdit && check && showTips;
                if (disableContactTypeEdit) {
                    return <Switch checked={(check && !showTips) || isRemoveAddressButChecked} disabled />;
                }
                if (showTips) {
                    return (
                        <div className={s.colDurWrap}>
                            <Popover
                                content={
                                    <div className={s.toolWrap}>
                                        This toggle is disabled because no practice address in this state is listed on
                                        your UniProfile. To enable in-person services, please add a practice address
                                        under UniProfile/Practice and update your services accordingly.
                                    </div>
                                }
                            >
                                <Switch
                                    disabled={
                                        (!allowAddressOptions || allowAddressOptions.length === 0) &&
                                        !isRemoveAddressButChecked
                                    }
                                    checked={(check && !showTips) || isRemoveAddressButChecked}
                                    onChange={(e) => {
                                        onInPersonChange(item, e);
                                    }}
                                />
                            </Popover>
                        </div>
                    );
                }
                return (
                    <div className={s.colDurWrap}>
                        <Switch
                            disabled={
                                (!allowAddressOptions || allowAddressOptions.length === 0) && !isRemoveAddressButChecked
                            }
                            checked={(check && !showTips) || isRemoveAddressButChecked}
                            onChange={(e) => {
                                onInPersonChange(item, e);
                            }}
                        />
                    </div>
                );
            },
        },
        ...(useInsuranceComponent && !isPPV
            ? [
                  {
                      title: (
                          <div className={s.tableTitle}>
                              <span>PLACE OF SERVICE CODE</span>
                              <Tooltip title="The code that tells payers where the visit happened. It's set automatically from your contact type: 10 for telehealth, 11 for in person. Telehealth claims also include modifier 95.">
                                  <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="17"
                                      height="17"
                                      viewBox="0 0 17 17"
                                      fill="none"
                                  >
                                      <path
                                          d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                          stroke="#6B7280"
                                          strokeWidth="1.33594"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                      />
                                  </svg>
                              </Tooltip>
                          </div>
                      ),
                      width: '250px',
                      render: (val: any, item: ServerMeta) => {
                          return (
                              <Select
                                  showSearch
                                  value={stateInPersonPosMap[item.content]}
                                  placeholder="Search a code"
                                  className={s.posSelect}
                                  filterOption={(input, option) =>
                                      (option?.label as string)?.toLowerCase().includes(input.toLowerCase())
                                  }
                                  onChange={(value) => onInPersonPosChange(item, value)}
                                  options={placeOfServiceCodeOptions.map((opt) => ({
                                      label: `${opt.code} — ${opt.name}`,
                                      value: opt.code,
                                  }))}
                              />
                          );
                      },
                  },
                  {
                      title: (
                          <div className={s.tableTitle}>
                              <span>MODIFIER</span>
                              <Tooltip title="A modifier code for in-person visits. Unlike telehealth, no default is set — select one if required by the payer.">
                                  <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="17"
                                      height="17"
                                      viewBox="0 0 17 17"
                                      fill="none"
                                  >
                                      <path
                                          d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                          stroke="#6B7280"
                                          strokeWidth="1.33594"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                      />
                                  </svg>
                              </Tooltip>
                          </div>
                      ),
                      width: '200px',
                      render: (val: any, item: ServerMeta) => {
                          const selectedModifier = stateInPersonModifierMap[item.content];
                          return (
                              <Select
                                  showSearch
                                  allowClear
                                  value={selectedModifier}
                                  placeholder="Search a code"
                                  className={s.posSelect}
                                  filterOption={(input, option) =>
                                      (option?.label as string)?.toLowerCase().includes(input.toLowerCase())
                                  }
                                  onChange={(value) => onInPersonModifierChange(item, value)}
                                  options={modifierOptions.map((opt) => ({
                                      label: `${opt.code} — ${opt.name}`,
                                      value: opt.code,
                                  }))}
                              />
                          );
                      },
                  },
              ]
            : []),
        {
            title: (
                <div className={s.tableTitle}>
                    <span>PRACTICE ADDRESS</span>
                    <Popover
                        placement="topLeft"
                        content={
                            <div className={s.toolWrap}>
                                Your practice addresses are managed in your UniProfile/Practice address. If you need to
                                add a new address, please update there and come back to this step.
                            </div>
                        }
                        trigger="hover"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                            <path
                                d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                stroke="#6B7280"
                                strokeWidth="1.33594"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </Popover>
                </div>
            ),
            width: '200px',
            render: (val, item: ServerMeta) => {
                if (isLaFireSpe) {
                    return null;
                }
                const addressIds = stateAddressIdsMap[item.content] || [];
                const showAddressSelect = (stateContactTypeMap[item.content] || []).includes(EContactType.IN_PERSON);
                const allowAddressOptions = addressOptions?.filter((add: PracitceAddressForm) => {
                    return (
                        (add.practiceState?.toLowerCase() === item.dictKey.toLowerCase() ||
                            add.practiceState?.toLowerCase() === item.content.toLowerCase()) &&
                        [AddressPublicType.INVITATION, AddressPublicType.WALK_IN].includes(add.publicType)
                    );
                });
                return (
                    <div className={s.addWrap}>
                        {showAddressSelect && (
                            <Select
                                mode="multiple"
                                value={addressIds}
                                style={{ width: '90%' }}
                                onChange={(ids) => {
                                    onAddressChange(item, ids);
                                }}
                                maxTagCount="responsive"
                                maxTagPlaceholder={(omittedValues) => (
                                    <Popover
                                        content={
                                            <div className={s.toolWrap}>
                                                {omittedValues.map(({ label }) => {
                                                    return <div key={label as string}>{label}</div>;
                                                })}
                                            </div>
                                        }
                                    >
                                        <span>+ {omittedValues.length} ...</span>
                                    </Popover>
                                )}
                            >
                                {allowAddressOptions.map((add) => {
                                    return (
                                        <Select.Option key={`${add.id}`} value={`${add.id}`}>
                                            {add.practiceAddress} ,{add.practiceCity}, {add.practiceState},{' '}
                                            {add.practiceZip}
                                        </Select.Option>
                                    );
                                })}
                            </Select>
                        )}
                    </div>
                );
            },
        },
    ];

    let showClose = !isAdd && serviceTypeTemplate?.mandatory === false;
    if (isOps) {
        showClose = true;
    } else {
        // if close by ops, can open
        // eslint-disable-next-line no-lonely-if
        if (serviceTypeTemplate?.mandatory === false && !defaultOpen) {
            showClose = true;
        }
    }

    if (klarityTemplate) {
        showClose = true;
    }

    if (forceHideCloseSwitch) {
        showClose = false;
    }

    React.useEffect(() => {
        if (
            forceDetectMedicationFlag &&
            !isDisabled &&
            isMedications &&
            medicationList &&
            medicationList.length === 0
        ) {
            setActiveKey([serviceTypeTemplate?.serviceType as string]);
            setShowMedicationEmpty(true);
        }
    }, [forceDetectMedicationFlag, showClose, isMedications, medicationList, serviceTypeTemplate]);

    // intable
    const insuranceCarriersAndPlansColumns: ColumnsType<ServerMeta> = [
        {
            title: 'STATE',
            dataIndex: 'dictKey',
            key: 'state',
        },
        {
            title: (
                <div className={s.tableTitle}>
                    <span>DURATION(MINS)</span>
                    <span className={s.icon}>
                        <Popover content={<div className={s.toolWrap}>{tips1}</div>} trigger="hover">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="17"
                                viewBox="0 0 17 17"
                                fill="none"
                            >
                                <path
                                    d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                    stroke="#6B7280"
                                    strokeWidth="1.33594"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Popover>
                    </span>
                </div>
            ),
            key: 'duration',
            width: '80px',
            render: (item: ServerMeta) => {
                const defalutVal =
                    serviceTypeTemplateValue?.duration !== undefined && serviceTypeTemplateValue?.duration !== null
                        ? serviceTypeTemplateValue.duration
                        : serviceTypeTemplate?.defaultDuration || 30;

                return (
                    <div className={s.colDurWrap}>
                        <InputNumber
                            value={stateContentInsuranceDurationMap[item.content]}
                            onChange={(e) => {
                                const _stateContentInsuranceDurationMap: Record<string, number> = {};
                                _stateContentInsuranceDurationMap[item.content] = e!;
                                setStateContentInsuranceDurationMap((prev) => ({
                                    ...prev,
                                    ..._stateContentInsuranceDurationMap,
                                }));
                            }}
                            size="small"
                            defaultValue={defalutVal}
                            onBlur={(e) => {
                                if (!e.target.value) {
                                    const _stateContentInsuranceDurationMap: Record<string, number> = {};
                                    _stateContentInsuranceDurationMap[item.content] = defalutVal!;
                                    setStateContentInsuranceDurationMap((prev) => ({
                                        ...prev,
                                        ..._stateContentInsuranceDurationMap,
                                    }));
                                }
                            }}
                            // max={serviceTypeTemplate?.maxDuration || 1000}
                            // min={serviceTypeTemplate?.minDuration || 0}
                        />
                    </div>
                );
            },
        },
        {
            title: 'INSURANCE CARRIER',
            dataIndex: 'carrier',
            key: 'carrier',
            render: (value: string, row: TInsuranceInput) => {
                const carriers = stateContentInsuranceCarrierMap[row.content!];
                return carriers && carriers.length > 0 ? (
                    <Select
                        style={{ width: '95%' }}
                        mode="multiple"
                        // value={stateContentInsuranceCarrierMap[item.content]}
                        value={carriers}
                        options={getCarrierOptions(row.dictKey!)}
                        onChange={(e) => {
                            const _stateContentInsuranceCarrierMap = {
                                ...stateContentInsuranceCarrierMap,
                            };
                            _stateContentInsuranceCarrierMap[row.content] = e;
                            setStateContentInsuranceCarrierMap(_stateContentInsuranceCarrierMap);
                            // 将选中的相关plans去除
                            const _stateContentInsurancePlanMap = {
                                ...stateContentInsurancePlanMap,
                            };
                            Object.keys(_stateContentInsurancePlanMap[row.content!]).forEach((carrier) => {
                                if (!e.includes(carrier)) {
                                    delete _stateContentInsurancePlanMap[row.content!][carrier];
                                }
                            });
                            setStateContentInsurancePlanMap(_stateContentInsurancePlanMap);
                        }}
                    />
                ) : (
                    <Button
                        type="link"
                        loading={insuranceLoading}
                        className={s.addInsurance}
                        onClick={() => {
                            setCurrentEditInsuranceRowData(row);
                            handleAddInsurance(row.dictKey as string);
                        }}
                    >
                        Add insurance
                    </Button>
                );
            },
        },
        {
            width: '200px',
            title: 'INSURANCE PLAN',
            dataIndex: 'plans',
            key: 'plans',
            render: (value: string, row: TInsuranceInput) => {
                const plans = stateContentInsurancePlanMap[row.content!];
                const noCarrierSelected =
                    !stateContentInsuranceCarrierMap[row.content!] ||
                    stateContentInsuranceCarrierMap[row.content!].length === 0;
                const plansValue = [];
                if (!noCarrierSelected && plans) {
                    Object.keys(plans)
                        .filter((e) => {
                            const carrier = e.split(splitsymbol)[0];
                            return stateContentInsuranceCarrierMap[row.content!].includes(carrier);
                        })
                        .forEach((carrier) => {
                            const carrierMap = plans[carrier].filter((e) => !!e);
                            if (typeof carrierMap === 'string') {
                                plansValue.push(carrierMap);
                            } else {
                                plansValue.push(
                                    ...carrierMap.map((item) => {
                                        if (item.indexOf(splitsymbol) > -1) {
                                            return item;
                                        }
                                        return `${carrier}${splitsymbol}${item}`;
                                    }),
                                );
                            }
                        });
                }

                if (!noCarrierSelected) {
                    return (
                        <Select
                            style={{ width: '95%' }}
                            mode="multiple"
                            value={plansValue}
                            options={getPlanOptions(row.dictKey!, row.content!)}
                            tagRender={(e) => {
                                const { label, onClose } = e;
                                return (
                                    <Tag
                                        onMouseDown={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }}
                                        closable
                                        onClose={onClose}
                                    >
                                        {label}
                                    </Tag>
                                );
                            }}
                            onChange={(e) => {
                                const newPlansMap = [];

                                e.forEach((item) => {
                                    const carrier = item.split(splitsymbol)[0];
                                    const plan = item.split(splitsymbol)[1];
                                    if (newPlansMap[carrier]) {
                                        newPlansMap[carrier].push(plan);
                                    } else {
                                        newPlansMap[carrier] = [plan];
                                    }
                                });
                                const _stateContentInsurancePlanMap = {
                                    ...stateContentInsurancePlanMap,
                                };
                                _stateContentInsurancePlanMap[row.content] = newPlansMap;
                                setStateContentInsurancePlanMap(_stateContentInsurancePlanMap);
                            }}
                        />
                    );
                }
                return null;
            },
        },
        {
            title: (
                <div className={s.tableTitle}>
                    PRIOR AUTHORIZATION SUPPORT
                    <Tooltip
                        overlayClassName={s.tipCard}
                        overlayInnerStyle={{ padding: '12px' }}
                        color="#FFFFFF"
                        title={
                            <div className={s.tipText}>
                                Handles insurance approval processes for procedures, medications, and services,
                                including documentation submission and appeal management for patients.
                            </div>
                        }
                    >
                        <div className={s.questionMarkIcon} />
                    </Tooltip>
                </div>
            ),
            dataIndex: 'priorAuthorizationSupport',
            key: 'priorAuthorizationSupport',
            render: (v: any, item: TInsuranceInput) => {
                return (
                    <Switch
                        checked={!!stateContentPriorAuthorizationSupportMap[item.content!]}
                        onChange={(e) => {
                            const _stateContentPriorAuthorizationSupportMap = {
                                ...stateContentPriorAuthorizationSupportMap,
                            };
                            _stateContentPriorAuthorizationSupportMap[item.content!] = e;
                            setStateContentPriorAuthorizationSupportMap(_stateContentPriorAuthorizationSupportMap);
                        }}
                    />
                );
            },
        },
    ].filter((item) => {
        if (isKiwiUser && pendingPaymentType.includes(PAMENT_TYPES.cash)) {
            return item.key !== 'duration';
        }
        if (!isKiwiUser) {
            return item.key !== 'priorAuthorizationSupport';
        }
        return true;
    });

    const handleControlledMedicationRefillsChange = (v: string) => {
        setPendingControlledMedicationRefillsType(v);
    };

    const handlePaymentChange = (v: number) => {
        setPaymentMethodName(paymentMethodNameMapToNumber[v] as unknown as number);
        let type = [v];
        if (v === PAMENT_TYPES.both) {
            type = [PAMENT_TYPES.cash, PAMENT_TYPES.insurance];
        }
        setPendingPaymentType(type);

        // if (pendingSaveData) {
        //     pendingSaveData.serviceStateItems.forEach((item) => {
        //         item.cashPay = type.includes(PAMENT_TYPES.cash);
        //         item.insurancePay = type.includes(PAMENT_TYPES.insurance);
        //     });
        //     pendingSaveData.cashPay = type.includes(PAMENT_TYPES.cash);
        //     pendingSaveData.insurancePay = type.includes(PAMENT_TYPES.insurance);

        //     onServiceTypeInfoUpdate?.(pendingSaveData as ServerKlarityService);
        // }
    };

    useEffect(() => {
        // 如果是edit， 就根据ServiceStateItems来确定。
        if (editValue) {
            const paymentTypeNumber = getPaymentType(editValue);
            setPaymentMethodName(paymentMethodNameMapToNumber[paymentTypeNumber]);

            if (paymentTypeNumber === PAMENT_TYPES.both) {
                setPendingPaymentType([PAMENT_TYPES.cash, PAMENT_TYPES.insurance]);
            } else {
                setPendingPaymentType([paymentTypeNumber]);
            }
        } else if (provider?.insurance.supportPayType === INSURANCE_TYPE_CASH) {
            setPendingPaymentType([PAMENT_TYPES.cash]);
            setPaymentMethodName(INSURANCE_TYPE_CASH);
        } else if (provider?.insurance.supportPayType === INSURANCE_TYPE_INSURANCE) {
            setPendingPaymentType([PAMENT_TYPES.insurance]);
            setPaymentMethodName(INSURANCE_TYPE_INSURANCE);
        } else if (provider?.insurance.supportPayType === INSURANCE_TYPE_CASH_AND_INSURANCE) {
            setPaymentMethodName(INSURANCE_TYPE_CASH_AND_INSURANCE);
            setPendingPaymentType([PAMENT_TYPES.cash, PAMENT_TYPES.insurance]);
        }
    }, [editValue, provider]);

    const paymentTypeRender = useMemo(() => {
        const providerData = provider;
        if (paymentTypeConfig) {
            if (paymentTypeConfig.cashPay && paymentTypeConfig.cashPay.show) {
                // if (providerData?.insurance.supportPayType === INSURANCE_TYPE_CASH) {
                return (
                    <Radio checked disabled={paymentTypeConfig.cashPay.disable}>
                        Cash pay
                    </Radio>
                );
                // }
            }
            if (paymentTypeConfig.insurancePay && paymentTypeConfig.insurancePay.show) {
                // if (providerData?.insurance.supportPayType === INSURANCE_TYPE_INSURANCE) {
                return (
                    <Radio checked disabled={paymentTypeConfig.insurancePay.disable}>
                        Insurance pay
                    </Radio>
                );
                // }
            }
        }
        // 这里不用supportPayTypeNew，因为providerData里面依然保持的是supportPayType
        if (providerData?.insurance.supportPayType === INSURANCE_TYPE_CASH) {
            return (
                <Radio checked disabled>
                    Cash pay
                </Radio>
            );
        } else if (providerData?.insurance.supportPayType === INSURANCE_TYPE_INSURANCE) {
            return (
                <Radio checked disabled>
                    Insurance pay
                </Radio>
            );
        }
        return (
            <>
                <Checkbox.Group
                    value={pendingPaymentType}
                    onChange={(value) => {
                        setPendingPaymentType(value as number[]);
                    }}
                >
                    <Checkbox value={PAMENT_TYPES.cash}>Cash pay</Checkbox>
                    <Checkbox value={PAMENT_TYPES.insurance}>Insurance pay</Checkbox>
                </Checkbox.Group>
                {(!pendingPaymentType || pendingPaymentType.length === 0) && (
                    <div className={s.errorText}>Please select a payment method.</div>
                )}
            </>
        );
    }, [isOps, provider, pendingPaymentType]);

    const serviceStateSelectDisabled = useMemo(() => {
        if (forceEnableStateSelect) {
            return false;
        }
        return (!isKiwiUser && !isEdit && serviceTypeTemplate?.serviceType === EServiceType.INIT) || isLaFireSpe;
    }, [forceEnableStateSelect, isEdit, isKiwiUser, isLaFireSpe, serviceTypeTemplate]);

    const abbrState = useMemo(() => {
        return states
            .map((state) => {
                return allStates?.find((item) => item.content === state || item.dictKey === state)?.dictKey;
            })
            .filter((item) => !!item);
    }, [allStates, states]);

    const handleMergeInsuranceTableData = useCallback((data?: ServerKlarityService) => {
        if (data) {
            setPendingInsuranceTableDataForMerge(data);
        }
        // const insuranceTableDataForMerge = insuranceTableRef.current?.getServerKlarityServiceData();

        // if (insuranceTableDataForMerge) {
        //     setPendingInsuranceTableDataForMerge(insuranceTableDataForMerge);
        // }
    }, []);

    useEffect(() => {
        setStates((pre) => pre.filter((item) => initialVisitSelectedStates?.includes(item)));
    }, [initialVisitSelectedStates]);

    const paymentRender = useMemo(() => {
        if (useInsuranceComponent) {
            let pendingPaymentTypeValue = pendingPaymentType[0];
            if (
                pendingPaymentType.length === 2 &&
                pendingPaymentType.includes(PAMENT_TYPES.cash) &&
                pendingPaymentType.includes(PAMENT_TYPES.insurance)
            ) {
                pendingPaymentTypeValue = PAMENT_TYPES.both;
            }
            return (
                <>
                    <div className={s.item}>
                        <div className={s.title}>{titleIndex.acceptedPaymentIndex}. Accepted payment</div>
                        <div className={s.des}>
                            Please select a payment method for your initial visit. Options are based on your
                            configuration.
                        </div>
                        <div className={s.selectWrap}>
                            <Radio.Group
                                value={pendingPaymentTypeValue}
                                onChange={(v) => handlePaymentChange(v.target.value)}
                            >
                                <Radio value={PAMENT_TYPES.cash}>Cash pay</Radio>
                                <Radio value={PAMENT_TYPES.insurance}>Insurance pay</Radio>
                                <Radio value={PAMENT_TYPES.both}>Both insurance and cash</Radio>
                            </Radio.Group>
                        </div>
                    </div>
                    <div className={s.item}>
                        <div className={s.title}>{titleIndex.paymentsIndex}. Payments</div>
                        <div className={s.des}>
                            Configure visit duration, insurance coverage, and cash pay pricing. Cash pay rates include
                            suggestions and can be updated every 30 days. See how other providers price their services
                            on HelloKlarity.com.
                        </div>
                        <div className={s.selectWrap}>
                            <InsuranceTable
                                isEdit={isManualEditToInsuranceTable}
                                ref={(ref) => {
                                    if (ref) {
                                        insuranceTableRef.current = ref;
                                    }
                                }}
                                hideDuration={isPrescriptionService}
                                states={abbrState}
                                servicePriceConfig={servicePriceConfig}
                                className={s.insuranceTable}
                                // onAddInsurance={handleAddInsurance}
                                paymentType={paymentMethodName}
                                selectedSpecialty={currentSpeciality}
                                initialInsuranceSettings={insuranceTableData}
                                showPriorAuthorizationSupport
                                showSuperBillSupport
                                onChange={(data) => {
                                    // setForceUpdate({});
                                    handleMergeInsuranceTableData(data);
                                }}
                                isOps={isOps}
                                providerIdForOps={providerId}
                            />
                        </div>
                    </div>
                    <div className={s.item}>
                        <div className={s.title}>
                            {titleIndex.billingCodesIndex}. Billing codes and rates (For Klarity EHR users only)
                        </div>
                        <div className={s.des}>
                            Set the billing codes and rates for this service. Codes are selected for each visit when the
                            note is signed. A rate is required for every code before Klarity can submit a claim.
                        </div>
                        <BillingCodesAndRates
                            initialValue={editValue?.cpts}
                            onChange={setPendingCptCodes}
                            specialty={service?.specialtyName}
                            isOps={isOps}
                            providerId={providerId}
                            autoSetInsuranceRate
                            defaultInsuranceRate={maxCashPayPrice}
                        />
                    </div>
                </>
            );
        }

        return (
            <>
                {isKiwiUser && (
                    <div className={s.item}>
                        <div className={s.title}>{titleIndex.acceptedPaymentIndex}. Accepted payment</div>
                        <div className={s.des}>
                            Please select a payment method for your initial visit. Options are based on your insurance
                            configuration.
                        </div>
                        <div className={s.selectWrap}>{paymentTypeRender}</div>
                    </div>
                )}
                {isKiwiUser && onlyInsurance ? null : (
                    <div className={s.item}>
                        <div className={s.title}>
                            {isMedications || isPrescriptionService
                                ? `${titleIndex.priceNDuration}. Price`
                                : `${titleIndex.priceNDuration}. Price and duration - Ava helped you to set up the competitive price in the markets.`}
                        </div>
                        {isKiwiUser && !isPrescriptionService && (
                            <div className={`${s.des} ${s.highlight}`}>
                                See how other providers price their services on{' '}
                                <a href="https://www.helloKlarity.com" target="_blank" rel="noreferrer">
                                    HelloKlarity.com
                                </a>
                                .
                            </div>
                        )}
                        {isMedications && (
                            <>
                                <div className={s.des}>
                                    Please set up the purchasing price of the medications in this section. You could add
                                    shipment fee as well. We generally encourage offering free shipping to make your
                                    services more competitive.
                                </div>
                                <div className={s.subTitle}>
                                    Flat shipment fee
                                    <span className={s.high}> *</span>
                                </div>
                                <div className={s.des}>
                                    We recommend you to set flat shipping fee for each state to simplify the patient
                                    payment experience. Once set up here, it will automatically be added to the
                                    patient's cost in all states.
                                </div>
                            </>
                        )}
                        <div className={s.tableWrap}>
                            <CommonTable
                                bordered
                                rowKey="dictKey"
                                columns={
                                    isMedications
                                        ? klarityServicePriceDataMedicationColumns()
                                        : klarityServicePriceDataColumns
                                }
                                data={
                                    states.map((st) => {
                                        return (allStates as ServerMeta[])?.find((item) => {
                                            return item.content === st || item.dictKey === st;
                                        });
                                    }) as ServerMeta[]
                                }
                                pagination={false}
                            />
                        </div>
                        {isLaFireSpe && (
                            <div className={s.tableTips}>
                                * Prices are fixed to maintain affordability for all patients in LA impacted by the
                                wildfires.
                            </div>
                        )}
                        {canEditPrice && !isLaFireSpe && (
                            <div className={s.tableTips}>
                                {isMedications ? (
                                    '*Prices can only be updated every 30 days.'
                                ) : (
                                    <div>
                                        *Prices can only be updated every 30 days. We recommend starting your services
                                        with the competitive prices calculated by{' '}
                                        <span className={s.ava}>
                                            <img src={AvaIcon} />
                                        </span>
                                        .
                                    </div>
                                )}
                            </div>
                        )}
                        {!canEditPrice && !isLaFireSpe && (
                            <div className={s.tableTips}>
                                *Prices cannot be updated until <b>{targetDate}</b>
                            </div>
                        )}
                        {showConsultationFree && (
                            <div className={s.consWrap}>
                                <div className={s.conLeft}>💡</div>
                                <div className={s.conRight}>
                                    Offering free consultations is a great way to connect with new patients and build
                                    trust. Klarity requires that consultations be offered free of charge, but you can
                                    turn off this service using the toggle in the top right corner if needed.
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {isKiwiUser && pendingPaymentType.includes(PAMENT_TYPES.insurance) && (
                    <div className={s.item}>
                        <div className={s.title}>{titleIndex.insuranceCarriersIndex}. Insurance carriers and plans</div>
                        <div className={s.des}>
                            The states, insurance carriers, and plans shown below are based on your insurance
                            configuration. You can make changes if needed.
                        </div>
                        <div className={s.tableWrap}>
                            <CommonTable
                                bordered
                                pagination={false}
                                rowKey="dictKey"
                                columns={insuranceCarriersAndPlansColumns}
                                data={
                                    states.map((st) => {
                                        return (allStates as ServerMeta[])?.find((item) => {
                                            return item.content === st || item.dictKey === st;
                                        });
                                    }) as ServerMeta[]
                                }
                                scroll={{ x: true }}
                            />
                        </div>
                    </div>
                )}
            </>
        );
    }, [
        handleMergeInsuranceTableData,
        abbrState,
        providerId,
        isOps,
        allStates,
        canEditPrice,
        currentSpeciality,
        insuranceCarriersAndPlansColumns,
        insuranceTableData,
        isKiwiUser,
        isLaFireSpe,
        isMedications,
        klarityServicePriceDataColumns,
        klarityServicePriceDataMedicationColumns,
        onlyInsurance,
        paymentMethodName,
        paymentTypeRender,
        pendingPaymentType,
        servicePriceConfig,
        showConsultationFree,
        states,
        targetDate,
        titleIndex.priceNDuration,
        useInsuranceComponent,
        isManualEditToInsuranceTable,
        titleIndex.acceptedPaymentIndex,
        titleIndex.billingCodesIndex,
        titleIndex.paymentsIndex,
        maxCashPayPrice,
    ]);

    const patientIntakeFormsRender = useMemo(() => {
        if (!showIntakeFormConfig) {
            return null;
        }
        const showDetail =
            pendingOpenPatientIntakeForms &&
            (showInitVisitBasicIntakeForm || showOtherBasicIntakeForm || showSpecificIntakeForm);
        return (
            <div className={`${s.item} ${s.itemIntake}`}>
                <div className={s.title}>
                    <div>{titleIndex.patientIntakeIndex}. Patient Intake Forms</div>
                    <div className={s.iSwitch}>
                        <Switch
                            checked={pendingOpenPatientIntakeForms}
                            onChange={(checked) => setPendingOpenPatientIntakeForms(checked)}
                        />
                    </div>
                </div>
                {showDetail && (
                    <div className={s.intakeInfo}>
                        {(showInitVisitBasicIntakeForm || showOtherBasicIntakeForm) && (
                            <div className={s.iiTips}>
                                Patients who book this visit with you will be guided through a short intake form that
                                collects the following information:
                            </div>
                        )}
                        {showInitVisitBasicIntakeForm && (
                            <div className={s.iiItem}>
                                <div className={s.iiItemTitle}>
                                    <span>General intake questions</span>
                                    <span
                                        onClick={() => {
                                            window.open(
                                                `${getHelloKlarityHost()}/consent-forms?specialty=${encodeURIComponent(`${currentSpecialityName}`)}&serviceType=${encodeURIComponent(serviceType)}&type=preview&previewType=${EIntakeFormType.BASIC_INITIAL_INTAKE_FORM}`,
                                                '_blank',
                                            );
                                        }}
                                        className={s.iiItemTitleLink}
                                    >
                                        Preview general intake forms
                                    </span>
                                </div>
                                <div className={s.iiItemDesRow}>
                                    <div className={s.iiItemDesCol}>
                                        <div className={s.iiiTitle}>Consents & acknowledgements</div>
                                        <ul>
                                            <li>Controlled Substances Acknowledgment</li>
                                            <li>Consent to obtain Medication History</li>
                                            <li>Self-Pay Agreement Policy</li>
                                            <li>Klarity Billing Policy </li>
                                            <li>HIPAA Form </li>
                                        </ul>
                                    </div>
                                    <div className={s.iiItemDesCol}>
                                        <div className={s.iiiTitle}>Demographics & contact information</div>
                                        <ul>
                                            <li>Gender</li>
                                            <li>Marital status</li>
                                            <li>Home address</li>
                                            <li>Emergency contact (name and phone number)</li>
                                            <li>Government-issued photo ID</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className={s.iiItemDesRow}>
                                    <div className={s.iiItemDesCol}>
                                        <div className={s.iiiTitle}>Medical history</div>
                                        {/* Current medical conditions
                                        Current medications and supplements
                                        Allergies */}
                                        <ul>
                                            <li>Current medical conditions</li>
                                            <li>Current medications and supplements</li>
                                            <li>Allergies</li>
                                        </ul>
                                    </div>
                                    <div className={s.iiItemDesCol}>
                                        <div className={s.iiiTitle}>Reason for visit</div>
                                        <ul>
                                            <li>Symptoms, concerns, or treatment goals</li>
                                            <li>
                                                Any specific medications or treatments they are seeking (if applicable)
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        )}
                        {showOtherBasicIntakeForm && (
                            <div className={s.iiItem}>
                                <div className={s.iiItemTitle}>
                                    <span>Confirm basic information</span>
                                </div>
                                <div className={s.iiItemDesRow}>
                                    <div className={s.iiItemDesCol}>
                                        {/* Name
                                    Date of birth
                                    Phone & email
                                    Marital status
                                    Home address
                                    Emergency contact (name and phone number) */}
                                        <ul>
                                            <li>Name</li>
                                            <li>Date of birth</li>
                                            <li>Phone & email</li>
                                            <li>Marital status</li>
                                            <li>Home address</li>
                                            <li>Emergency contact (name and phone number)</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        )}
                        {showSpecificIntakeForm && (
                            <div className={s.iiItem}>
                                <div className={s.iiItemTitle}>
                                    <span>{currentSpecialityName} - specific intake</span>
                                    <span
                                        onClick={() => {
                                            window.open(
                                                `${getHelloKlarityHost()}/consent-forms?specialty=${encodeURIComponent(`${currentSpecialityName}`)}&serviceType=${encodeURIComponent(serviceType)}&type=preview&previewType=${EIntakeFormType.SPECIFIC_INTAKE_FORM}`,
                                                '_blank',
                                            );
                                        }}
                                        className={s.iiItemTitleLink}
                                    >
                                        Preview specialty-specific intake forms
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }, [
        showIntakeFormConfig,
        titleIndex.patientIntakeIndex,
        pendingOpenPatientIntakeForms,
        showInitVisitBasicIntakeForm,
        showOtherBasicIntakeForm,
        showSpecificIntakeForm,
        currentSpecialityName,
    ]);

    return (
        <div className={s.wrap}>
            {modalVisible && (
                <InsuranceSelectionModal
                    planWithCarrierName
                    splitsymbol={splitsymbol}
                    visible
                    onCancel={() => setModalVisible(false)}
                    onSave={handleSave}
                    insuranceList={insuranceCarrierOptions}
                    state={currentEditInsuranceRowData?.content!}
                />
            )}
            <Collapse
                expandIcon={(pop) => {
                    return (
                        <div className={`${s.popWrap} ${pop.isActive ? s.rotate : ''}`}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 25 25"
                                fill="none"
                            >
                                <path
                                    d="M19.5 9.96875L12.5 16.9688L5.5 9.96875"
                                    stroke="#111827"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                    );
                }}
                activeKey={isDisabled ? [] : activeKey}
                ghost
                expandIconPosition="end"
                onChange={(key: string | string[]) => {
                    setActiveKey((key as string[]).filter((k) => k !== ''));
                }}
            >
                <Collapse.Panel
                    forceRender
                    header={
                        <div className={s.header}>
                            <span>
                                {displayName}{' '}
                                {isPrescriptionService
                                    ? '(Asynchronous, prescription only, no medication will be provided)'
                                    : ''}
                            </span>
                            {isAdd && <Button onClick={onRemove}>Remove</Button>}
                            {showClose && (
                                <span className={s.mandatory}>
                                    <Switch
                                        checked={!isDisabled}
                                        onChange={(e) => {
                                            setIsDisabled(!e);
                                            onDisabled?.(!e);
                                        }}
                                    />
                                </span>
                            )}
                        </div>
                    }
                    key={serviceTypeTemplate?.serviceType as string}
                >
                    <div className={s.content}>
                        <div className={s.item}>
                            {/* {showIntakeFormConfig && ( */}
                            {isPrescriptionService && (
                                <div className={s.prescriptionNote}>
                                    <div className={s.preLeft}>💡️️</div>
                                    <div className={s.preRight}>
                                        <p>
                                            Offer prescription refills through an asynchronous text visit only. Patients
                                            submit a refill request, and you review and respond without a live visit.
                                        </p>
                                        <p>
                                            If you prefer to prescribe medications during a live interaction, you can
                                            continue to do so through follow-up visits (video or in-person).
                                        </p>
                                    </div>
                                </div>
                            )}
                            {isMedications && (
                                <div className={s.mNote}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="21"
                                        viewBox="0 0 20 21"
                                        fill="none"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M18 10.8281C18 15.2464 14.4183 18.8281 10 18.8281C5.58172 18.8281 2 15.2464 2 10.8281C2 6.40985 5.58172 2.82812 10 2.82812C14.4183 2.82812 18 6.40985 18 10.8281ZM11 6.82812C11 7.38041 10.5523 7.82812 10 7.82812C9.44772 7.82812 9 7.38041 9 6.82812C9 6.27584 9.44772 5.82812 10 5.82812C10.5523 5.82812 11 6.27584 11 6.82812ZM9 9.82812C8.44772 9.82812 8 10.2758 8 10.8281C8 11.3804 8.44772 11.8281 9 11.8281V14.8281C9 15.3804 9.44772 15.8281 10 15.8281H11C11.5523 15.8281 12 15.3804 12 14.8281C12 14.2758 11.5523 13.8281 11 13.8281V10.8281C11 10.2758 10.5523 9.82812 10 9.82812H9Z"
                                            fill="#60A5FA"
                                        />
                                    </svg>
                                    <p>
                                        On this page, you can set up a service to provide your patients with medications
                                        directly from your practice. You agree to offer accurate medication information,
                                        handle shipping arrangements, and provide instructions for medication adherence.
                                        If you only offer prescriptions, please set up the 'Prescription Service'
                                        section.
                                    </p>
                                </div>
                            )}
                            <div className={s.title}>1. Applied states</div>
                            <div className={s.des}>
                                {isKiwiUser
                                    ? `For your ${serviceTypeTemplate?.serviceType} setup, the states listed below are based on the licenses you've uploaded. You can add more states if needed.`
                                    : 'Removing states here will make this service type unavailable in those states and eliminates the need for further setup like price and duration.'}
                            </div>
                            <div className={s.setStateWrap}>
                                <Select
                                    mode="multiple"
                                    style={{ width: '360px' }}
                                    value={states}
                                    onChange={(contents) => {
                                        if (!contents || contents.length === 0) {
                                            return;
                                        }
                                        setIsManualEditToInsuranceTable(true);
                                        setStates(contents);
                                        if (isInit && onInitVisitStateChange) {
                                            onInitVisitStateChange(
                                                (allStates as ServerMeta[])?.filter((item) =>
                                                    contents.includes(item.content),
                                                ) || [],
                                            );
                                        }
                                    }}
                                    maxTagCount="responsive"
                                    disabled={serviceStateSelectDisabled}
                                    // tagRender={(pop) => {
                                    //     const target = allowStates?.find((item) => item.dictKey === pop.value);
                                    //     return <span className={s.displayLabel}>{target ? target.content : pop.value}</span>;
                                    // }}
                                >
                                    {statesOption?.map((ste: ServerMeta) => {
                                        let isDisabledOoptions = isKiwiUser
                                            ? !isInit &&
                                              !isConsultation &&
                                              !initialVisitSelectedStates?.includes(ste.content)
                                            : isInit && initStatesFromEdit.includes(ste.content);

                                        if (forceEnableStateSelect) {
                                            isDisabledOoptions = false;
                                        }
                                        return (
                                            <Select.Option
                                                disabled={
                                                    // !isKiwiUser && isInit && initStatesFromEdit.includes(ste.content)
                                                    // isKiwiUser ?
                                                    //     (!isInit && !isConsultation) && !initialVisitSelectedStates?.includes(ste.content) :
                                                    //     isInit && initStatesFromEdit.includes(ste.content)
                                                    isDisabledOoptions
                                                }
                                                key={ste.content}
                                                value={ste.content}
                                            >
                                                {ste.content}
                                            </Select.Option>
                                        );
                                    })}
                                </Select>
                            </div>
                            {isKiwiUser && isInit && (
                                // <div className={s.kiwiTips}>
                                //     <div className={s.left}>💡️️</div>
                                //     <div className={s.right}>
                                //         To add other services in a state (such as established patient visits, consultations, medication refills, and other patient support), you must first offer initial visits for that specialty within the state.
                                //     </div>
                                // </div>
                                <div className={s.otherTips}>
                                    <div className={s.left}>💡</div>
                                    <div className={s.right}>
                                        To add other services in a state (such as established patient visits,
                                        consultations, medication refills, and other patient support), you must first
                                        offer initial visits for that specialty within the state.
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className={s.item}>
                            <div className={s.title}>2. Name and description</div>
                            {serviceType === EServiceType.OTHER_PATIENT_SUPPORT && (
                                <div className={s.otherTips}>
                                    <div className={s.left}>💡</div>
                                    <div className={s.right}>
                                        You can offer a range of services including documentation or paperwork support,
                                        lab test prescriptions, and in-depth research for referrals. Additionally,
                                        consider providing webinars, courses, and educational materials to further
                                        support and educate your patients.
                                    </div>
                                </div>
                            )}
                            <div className={s.sub1}>Service name</div>
                            {isLaFireSpe && (
                                <div className={s.name}>
                                    <span
                                        style={{
                                            color: 'rgba(107, 114, 128, 1)',
                                        }}
                                    >
                                        Telehealth visit & prescription refill
                                    </span>
                                    <span
                                        style={{
                                            color: 'rgba(55, 65, 81, 1)',
                                        }}
                                    >
                                        : new patient initial visit California
                                    </span>
                                </div>
                            )}
                            {!isLaFireSpe && (
                                <>
                                    {hasNameTips && !isKiwiUser && (
                                        <div className={s.nameTips}>
                                            <div className={s.left}>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M5 2C5.55228 2 6 2.44772 6 3V4H7C7.55228 4 8 4.44772 8 5C8 5.55228 7.55228 6 7 6H6V7C6 7.55228 5.55228 8 5 8C4.44772 8 4 7.55228 4 7V6H3C2.44772 6 2 5.55228 2 5C2 4.44772 2.44772 4 3 4H4V3C4 2.44772 4.44772 2 5 2ZM5 12C5.55228 12 6 12.4477 6 13V14H7C7.55228 14 8 14.4477 8 15C8 15.5523 7.55228 16 7 16H6V17C6 17.5523 5.55228 18 5 18C4.44772 18 4 17.5523 4 17V16H3C2.44772 16 2 15.5523 2 15C2 14.4477 2.44772 14 3 14H4V13C4 12.4477 4.44772 12 5 12Z"
                                                        fill="#FBBF24"
                                                    />
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M11.9999 2C12.4537 2 12.8505 2.30548 12.9667 2.74411L14.1459 7.19893L17.4997 9.13381C17.8092 9.31241 17.9999 9.64262 17.9999 10C17.9999 10.3574 17.8092 10.6876 17.4997 10.8662L14.1459 12.8011L12.9667 17.2559C12.8505 17.6945 12.4537 18 11.9999 18C11.5462 18 11.1493 17.6945 11.0332 17.2559L9.85402 12.8011L6.50027 10.8662C6.19072 10.6876 6 10.3574 6 10C6 9.64262 6.19072 9.31241 6.50027 9.13382L9.85402 7.19893L11.0332 2.74411C11.1493 2.30548 11.5462 2 11.9999 2Z"
                                                        fill="#FBBF24"
                                                    />
                                                </svg>
                                            </div>
                                            <div className={s.right}>{targetNameTips.reminder}</div>
                                        </div>
                                    )}
                                    <div
                                        className={`${s.error} ${
                                            nameIsExistInServerError || nameExistInEditing ? s.errorShow : ''
                                        }`}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L8.58579 10L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071L10 11.4142L11.2929 12.7071C11.6834 13.0976 12.3166 13.0976 12.7071 12.7071C13.0976 12.3166 13.0976 11.6834 12.7071 11.2929L11.4142 10L12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289C12.3166 6.90237 11.6834 6.90237 11.2929 7.29289L10 8.58579L8.70711 7.29289Z"
                                                fill="#F87171"
                                            />
                                        </svg>
                                        <span>
                                            This service name already exists. Please customize the name to distinguish
                                            this {displayName} from others.
                                        </span>
                                    </div>
                                    <div className={s.name}>
                                        {!isKiwiUser && <span className={s.nameText}>{service?.specialtyName}</span>}
                                        <Input
                                            placeholder="Optional for your customized input"
                                            className={s.input}
                                            maxLength={50}
                                            size="small"
                                            value={pendingCustomizeName}
                                            onChange={(e) => {
                                                setPendingCustomizeName(e.target.value);
                                            }}
                                            onBlur={() => {
                                                checkPendingServiceTypeName();
                                            }}
                                        />
                                        {hasNameTips && (
                                            <Popover
                                                placement="bottomLeft"
                                                content={<div className={s.toolWrap}>{targetNameTips.toolTips}</div>}
                                                trigger="hover"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="17"
                                                    height="17"
                                                    viewBox="0 0 17 17"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                                        stroke="#6B7280"
                                                        strokeWidth="1.33594"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </Popover>
                                        )}
                                        <span style={{ marginLeft: '6px' }}>: {displayName} [States] </span>
                                    </div>
                                    <div className={s.sub2}>
                                        {isKiwiUser ? 'How this will appear to patients' : 'Example'}:{' '}
                                        {service?.specialtyName} <span className={s.hight}>{pendingCustomizeName}</span>
                                        : {displayName} [California]
                                    </div>
                                </>
                            )}
                            <div className={s.desInputWrap}>
                                <div className={s.sub1}>Description</div>
                                {isLaFireSpe && (
                                    <div className={s.des1}>
                                        <p>
                                            15min quick telehealth visits designed to diagnose common symptoms and
                                            prescribe non-controlled medications. Services primary related to symptom
                                            assessment and / or prescription refills for allergies, asthma, cold sores,
                                            dehydration, eye irritation, fever, hypertension management, health risk
                                            assessments, insomnia, migraines, smoke inhalation, urgent care, anxiety,
                                            grief, PTSD, panic attacks, trauma, and all other types of symptoms as the
                                            providers see fit. Providers with specialized expertise have the flexibility
                                            to include specialty care services based on their qualifications and
                                            capacity.
                                        </p>
                                        <p>Note *: controlled substances are excluded from this service.</p>
                                    </div>
                                )}
                                {!isLaFireSpe && (
                                    <Input.TextArea
                                        rows={5}
                                        maxLength={1000}
                                        className={s.desInput}
                                        onChange={(e) => {
                                            setPendingDescription(e.target.value);
                                        }}
                                        value={pendingDescription}
                                    />
                                )}
                            </div>
                        </div>
                        {isMedications && (
                            <div className={s.item}>
                                <div className={s.title}>3. Medication information</div>
                                {/* <div className={s.des}>
                                        You haven't added any medications. Click 'Add medications' to include your medications.
                                    </div> */}
                                <div className={s.selectWrap}>
                                    <MedicationSelect
                                        defaultValue={defaultMedicationList}
                                        onChange={(item) => {
                                            setMedicationList(item);
                                            if (!item || item.length === 0) {
                                                setShowMedicationEmpty(true);
                                            } else {
                                                setShowMedicationEmpty(false);
                                            }
                                        }}
                                        isOps={isOps}
                                        providerId={providerId}
                                    />
                                </div>
                                {showMedicationEmpty && (
                                    <div className={`${s.emptyMedication} emptyMedication`}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="21"
                                            viewBox="0 0 20 21"
                                            fill="none"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M8.25413 3.92573C9.01874 2.56642 10.9758 2.56642 11.7404 3.92573L17.3207 13.8463C18.0707 15.1795 17.1072 16.8268 15.5776 16.8268H4.41697C2.88732 16.8268 1.92389 15.1795 2.67382 13.8463L8.25413 3.92573ZM10.9972 13.8269C10.9972 14.3792 10.5495 14.8269 9.99719 14.8269C9.44491 14.8269 8.99719 14.3792 8.99719 13.8269C8.99719 13.2746 9.44491 12.8269 9.99719 12.8269C10.5495 12.8269 10.9972 13.2746 10.9972 13.8269ZM9.99719 5.8269C9.44491 5.8269 8.99719 6.27462 8.99719 6.8269V9.8269C8.99719 10.3792 9.44491 10.8269 9.99719 10.8269C10.5495 10.8269 10.9972 10.3792 10.9972 9.8269V6.8269C10.9972 6.27462 10.5495 5.8269 9.99719 5.8269Z"
                                                fill="#EF4444"
                                            />
                                        </svg>
                                        To save this service, please add a medication or disable the medications service
                                        type.
                                    </div>
                                )}
                            </div>
                        )}
                        {showControlledMedicationRefills && (
                            <div className={s.item}>
                                <div className={s.title}>3. Controlled medication refills</div>
                                <div className={s.des}>
                                    Do you allow patients to request controlled medication refills through an
                                    asynchronous text visit?
                                </div>
                                <div className={s.selectWrap}>
                                    <Radio.Group
                                        value={pendingControlledMedicationRefillsType}
                                        onChange={(v) => handleControlledMedicationRefillsChange(v.target.value)}
                                    >
                                        <Radio value={CONTROLED_MEDICATION_REFILLS_TYPES.yes}>Yes</Radio>
                                        <Radio value={CONTROLED_MEDICATION_REFILLS_TYPES.no}>No</Radio>
                                    </Radio.Group>
                                </div>
                                {pendingControlledMedicationRefillsType === CONTROLED_MEDICATION_REFILLS_TYPES.yes && (
                                    <div className={s.refillAmount}>
                                        <div className={s.refTitle}>
                                            <span>Maximum number of asynchronous refills</span>
                                            <InputNumber
                                                value={pendingControlledMedicationRefillsMaxAmount}
                                                onChange={(v) =>
                                                    setPendingControlledMedicationRefillsMaxAmount(v || undefined)
                                                }
                                                placeholder="e.g 3"
                                                step={1}
                                            />
                                        </div>
                                        <div className={s.refDes}>
                                            How many times a patient can request a controlled medication refill
                                            asynchronously before a face-to-face visit (video or in-person) is required.
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                        {paymentRender}

                        {serviceTypeTemplate?.switchTeleHealthInPerson && !isMedications && (
                            <div className={s.item}>
                                {/* <div className={s.title}>
                                    {`${titleIndex.contactTypeIndex}. Contact type and place of service - ${
                                        isKiwiUser
                                            ? 'Ava used your practice address prefilled your contact type'
                                            : 'Choose how you want to connect with your patients in this service'
                                    }`}
                                </div> */}
                                <div className={s.title}>
                                    {`${titleIndex.contactTypeIndex}. Contact type and place of service`}
                                </div>
                                <div className={s.tableWrap}>
                                    <CommonTable
                                        bordered
                                        pagination={false}
                                        rowKey="dictKey"
                                        columns={contactDataColumns}
                                        scroll={{ x: 'max-content' }}
                                        data={
                                            states.map((st) => {
                                                return (allStates as ServerMeta[])?.find((item) => {
                                                    return item.content === st || item.dictKey === st;
                                                });
                                            }) as ServerMeta[]
                                        }
                                    />
                                </div>
                            </div>
                        )}

                        {serviceTypeTemplate?.switchPatientGroupLimitation && !isMedications && (
                            <div className={s.item}>
                                <div className={s.title}>
                                    <span>{titleIndex.patientGroupIndex}. Patient group and limitations</span>
                                    <span
                                        onClick={() => {
                                            setPgiIsOpen(!pgiIsOpen);
                                        }}
                                        className={s.switch}
                                    >
                                        {pgiIsOpen ? (
                                            <span>Hide patient group and limitations</span>
                                        ) : (
                                            <span>Show patient group and limitations</span>
                                        )}
                                        <span className={`${s.icon} ${pgiIsOpen && s.iconRotate}`}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="21"
                                                height="21"
                                                viewBox="0 0 21 21"
                                                fill="none"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M5.79289 8.26164C6.18342 7.87112 6.81658 7.87112 7.2071 8.26164L10.5 11.5545L13.7929 8.26164C14.1834 7.87112 14.8166 7.87112 15.2071 8.26164C15.5976 8.65217 15.5976 9.28533 15.2071 9.67586L11.2071 13.6759C10.8166 14.0664 10.1834 14.0664 9.79289 13.6759L5.79289 9.67586C5.40237 9.28533 5.40237 8.65217 5.79289 8.26164Z"
                                                    fill="#00816B"
                                                />
                                            </svg>
                                        </span>
                                    </span>
                                </div>
                                <div className={`${s.pglWrap} ${pgiIsOpen ? s.pglWrapOpen : ''}`}>
                                    {pendingPgiInfo?.map((pgi: PigInfo, inx) => {
                                        const allPgiLmitOption = [...pgiLmitOption, ...pgiLmitExtraOption];
                                        const setedState: string[] = [];
                                        const hasSelectedState = pgi.states && pgi.states.length > 0;
                                        pendingPgiInfo.forEach((info: PigInfo, inxP) => {
                                            if (inxP === inx) {
                                                return;
                                            }
                                            info.states?.forEach((st) => {
                                                if (!setedState.includes(st.content)) {
                                                    setedState.push(st.content);
                                                }
                                            });
                                        });
                                        const _allowStates = isKiwiUser ? (allStates as ServerMeta[]) : allowStates;
                                        const _statesOption = _allowStates?.filter((item) => {
                                            if (setedState && setedState.length > 0) {
                                                const find = setedState.find((st: string) => {
                                                    return st === item.content || st === item.dictKey;
                                                });
                                                if (find) {
                                                    return false;
                                                }
                                            }
                                            return states.includes(item.content) || states.includes(item.dictKey);
                                        });
                                        return (
                                            <div className={s.pigItemWrap} key={`${inx}`}>
                                                <div className={s.pigStateWrap}>
                                                    <div className={s.left}>
                                                        <div className={s.leftIn}>
                                                            <div className={s.label}>Applied states:</div>
                                                            <div className={s.pigInputWrap}>
                                                                <Select
                                                                    mode="multiple"
                                                                    value={pgi.states?.map((st) => st.content)}
                                                                    style={{
                                                                        width: '360px',
                                                                    }}
                                                                    onChange={(stateContents: string[]) => {
                                                                        const _states = _allowStates?.filter((st) => {
                                                                            return (
                                                                                stateContents?.includes(st.content) ||
                                                                                stateContents?.includes(st.dictKey)
                                                                            );
                                                                        });
                                                                        onPigStateChange(inx, _states || []);
                                                                    }}
                                                                    disabled={isLaFireSpe}
                                                                    maxTagCount="responsive"
                                                                    // tagRender={(pop) => {
                                                                    //     const target = allowStates?.find((item) => item.dictKey === pop.value);
                                                                    //     return <span className={s.displayLabel}>{target ? target.content : pop.value}</span>;
                                                                    // }}
                                                                >
                                                                    {_statesOption?.map((ste: ServerMeta) => {
                                                                        return (
                                                                            <Select.Option
                                                                                key={ste.content}
                                                                                value={ste.content}
                                                                            >
                                                                                {ste.content}
                                                                            </Select.Option>
                                                                        );
                                                                    })}
                                                                </Select>
                                                            </div>
                                                        </div>
                                                        {isLaFireSpe && (
                                                            <div className={s.emptyState}>
                                                                Bookings are limited to California, and state
                                                                restrictions cannot be removed or modified. Patients
                                                                from California are accepted without any limitations.
                                                            </div>
                                                        )}
                                                        {!hasSelectedState && (
                                                            <div className={s.emptyState}>
                                                                Removing all state restrictions allows bookings from all
                                                                practice states, accepting patients without any
                                                                limitations.
                                                            </div>
                                                        )}
                                                    </div>
                                                    {inx > 0 && (
                                                        <div
                                                            onClick={() => {
                                                                const _pendingPgiInfo = [...pendingPgiInfo];
                                                                _pendingPgiInfo.splice(inx, 1);
                                                                setPendingPgiInfo(_pendingPgiInfo);
                                                            }}
                                                            className={s.right}
                                                        >
                                                            <Button>Remove</Button>
                                                        </div>
                                                    )}
                                                </div>

                                                <div className={s.pigContactWrap}>
                                                    <div className={s.label}>Applied contact type:</div>
                                                    <div className={s.pigInputWrap}>
                                                        <Checkbox.Group
                                                            disabled={!hasSelectedState || isLaFireSpe}
                                                            onChange={(val) => {
                                                                onPigContactTypeChange(inx, val as EContactType[]);
                                                            }}
                                                            value={pgi.contactType}
                                                            options={contactTypeOption}
                                                        />
                                                    </div>
                                                </div>
                                                <div className={s.subText}>Patient accepted</div>
                                                <div className={s.accept}>
                                                    <Checkbox.Group
                                                        disabled={!hasSelectedState}
                                                        onChange={(val) => {
                                                            if (!val) {
                                                                onPigAcceptChange(inx, []);
                                                                return;
                                                            }
                                                            const cut = pgi.accept;
                                                            if (!cut?.includes('all') && val?.includes('all')) {
                                                                onPigAcceptChange(inx, [
                                                                    ...pgiAcceptOption.map((str) => str.value),
                                                                    'all',
                                                                ]);
                                                                return;
                                                            }
                                                            if (cut?.includes('all') && !val?.includes('all')) {
                                                                //clear all
                                                                onPigAcceptChange(inx, []);
                                                                return;
                                                            }
                                                            if (
                                                                val.length === pgiAcceptOption.length &&
                                                                !val.includes('all')
                                                            ) {
                                                                onPigAcceptChange(inx, [...(val as string[]), 'all']);
                                                                return;
                                                            }
                                                            if (val.includes('all')) {
                                                                onPigAcceptChange(
                                                                    inx,
                                                                    (val as string[]).filter((str) => str !== 'all'),
                                                                );
                                                                return;
                                                            }
                                                            onPigAcceptChange(inx, val as string[]);
                                                        }}
                                                        value={pgi.accept}
                                                        className={s.checkAccpet}
                                                    >
                                                        <div className={s.rowWrap}>
                                                            {updatedPgiAcceptOption?.map((str) => {
                                                                return (
                                                                    <div className={s.colWrap} key={str.label}>
                                                                        <Checkbox value={str.value} key={str.value}>
                                                                            {str.label}
                                                                        </Checkbox>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </Checkbox.Group>
                                                </div>

                                                <div className={s.subText}>
                                                    <span>Limitations</span>
                                                    <Popover
                                                        placement="topLeft"
                                                        content={
                                                            <div className={s.toolWrap}>
                                                                The limitation you set here will be displayed on your
                                                                profile to support better patient matching
                                                            </div>
                                                        }
                                                        trigger="hover"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="17"
                                                            height="17"
                                                            viewBox="0 0 17 17"
                                                            fill="none"
                                                        >
                                                            <path
                                                                d="M5.99582 6.98047C6.36261 6.20216 7.35231 5.64453 8.51566 5.64453C9.9913 5.64453 11.1875 6.54171 11.1875 7.64844C11.1875 8.58322 10.3341 9.36851 9.17977 9.58995C8.81747 9.65946 8.51566 9.9514 8.51566 10.3203M8.51562 12.3242H8.5223M14.5273 8.98438C14.5273 12.3046 11.8358 14.9961 8.51562 14.9961C5.19544 14.9961 2.50391 12.3046 2.50391 8.98438C2.50391 5.66419 5.19544 2.97266 8.51562 2.97266C11.8358 2.97266 14.5273 5.66419 14.5273 8.98438Z"
                                                                stroke="#6B7280"
                                                                strokeWidth="1.33594"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </Popover>
                                                </div>
                                                <div className={s.accept}>
                                                    <Checkbox.Group
                                                        onChange={(val) => {
                                                            onPigLimitChange(inx, val as string[]);
                                                        }}
                                                        value={pgi.limitations}
                                                        className={s.checkAccpet}
                                                        disabled={!hasSelectedState}
                                                    >
                                                        <div className={s.limitWrap}>
                                                            {allPgiLmitOption?.map((str) => {
                                                                return (
                                                                    <div key={str.label}>
                                                                        <Checkbox value={str.value} key={str.value}>
                                                                            {str.label}
                                                                        </Checkbox>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </Checkbox.Group>
                                                </div>
                                                {pgi.isAddingLimit && hasSelectedState && (
                                                    <div className={s.extraLimitWrap}>
                                                        <Input
                                                            value={pgi.pendingNewLimit}
                                                            onChange={(e) => {
                                                                onPigNewLimitChange(inx, e.target.value);
                                                            }}
                                                            placeholder="Add a limitation"
                                                            maxLength={100}
                                                        />
                                                        <Button
                                                            onClick={() => {
                                                                onPigNewLimitChangeConfirm(inx);
                                                            }}
                                                            className={s.btn}
                                                            type="primary"
                                                            disabled={!pgi.pendingNewLimit}
                                                        >
                                                            Add
                                                        </Button>
                                                        <Button
                                                            onClick={() => {
                                                                onPigIsAddingLimitChange(inx, false);
                                                            }}
                                                            className={s.btn}
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </div>
                                                )}
                                                {!pgi.isAddingLimit && hasSelectedState && (
                                                    <div
                                                        onClick={() => {
                                                            onPigIsAddingLimitChange(inx, true);
                                                        }}
                                                        className={s.extraLimitButton}
                                                    >
                                                        + Add a limitation
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                    {allHasSelectState && !allStateSeted && (
                                        <div
                                            onClick={() => {
                                                const patientGroupIds =
                                                    serviceTypeTemplateValue?.patientGroupIds?.split(',') || [];
                                                const limitationIds =
                                                    serviceTypeTemplateValue?.limitationIds?.split(',') || [];
                                                const accept: string[] =
                                                    serviceTypeTemplate?.klarityServiceTypePatientGroupList
                                                        ?.filter((i) => {
                                                            return patientGroupIds.includes(`${i.id}`);
                                                        })
                                                        ?.map((i) => i.patientGroup) || [];
                                                const limitations: string[] =
                                                    serviceTypeTemplate?.klarityServiceTypeLimitationList
                                                        ?.filter((i) => {
                                                            return limitationIds.includes(`${i.id}`);
                                                        })
                                                        ?.map((i) => i.limitation) || [];
                                                const _pendingPgiInfo: PigInfo[] = [
                                                    ...pendingPgiInfo,
                                                    {
                                                        accept: accept || [],
                                                        limitations: limitations || [],
                                                    },
                                                ];
                                                setPendingPgiInfo(_pendingPgiInfo);
                                            }}
                                            className={s.addPgi}
                                        >
                                            + Add patient group and limitations for other states
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        {patientIntakeFormsRender}
                    </div>
                </Collapse.Panel>
            </Collapse>
        </div>
    );
};

export default ConfigServiceType;
